
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaec0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaec0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("53wU4", function(module, exports) {
module.exports = 0.000001;

});

parcelRegister("czATl", function(module, exports) {
module.exports = $92755ed082560e2e$var$create;
/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */ function $92755ed082560e2e$var$create() {
    var out = new Float32Array(3);
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    return out;
}

});

parcelRegister("ktIj8", function(module, exports) {
module.exports = $ee88e2a12b501ee5$var$clone;
/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {vec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */ function $ee88e2a12b501ee5$var$clone(a) {
    var out = new Float32Array(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}

});

parcelRegister("fOLkG", function(module, exports) {
module.exports = $b8403dd22e76e9d3$var$angle;

var $5p9Yc = parcelRequire("5p9Yc");

var $dKsAX = parcelRequire("dKsAX");

var $a5Tdg = parcelRequire("a5Tdg");
/**
 * Get the angle between two 3D vectors
 * @param {vec3} a The first operand
 * @param {vec3} b The second operand
 * @returns {Number} The angle in radians
 */ function $b8403dd22e76e9d3$var$angle(a, b) {
    var tempA = $5p9Yc(a[0], a[1], a[2]);
    var tempB = $5p9Yc(b[0], b[1], b[2]);
    $dKsAX(tempA, tempA);
    $dKsAX(tempB, tempB);
    var cosine = $a5Tdg(tempA, tempB);
    if (cosine > 1.0) return 0;
    else return Math.acos(cosine);
}

});
parcelRegister("5p9Yc", function(module, exports) {
module.exports = $3ef7055e040c933b$var$fromValues;
/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */ function $3ef7055e040c933b$var$fromValues(x, y, z) {
    var out = new Float32Array(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}

});

parcelRegister("dKsAX", function(module, exports) {
module.exports = $a025c09e4598a805$var$normalize;
/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to normalize
 * @returns {vec3} out
 */ function $a025c09e4598a805$var$normalize(out, a) {
    var x = a[0], y = a[1], z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
        out[2] = a[2] * len;
    }
    return out;
}

});

parcelRegister("a5Tdg", function(module, exports) {
module.exports = $75953322ed55cdc6$var$dot;
/**
 * Calculates the dot product of two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} dot product of a and b
 */ function $75953322ed55cdc6$var$dot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

});


parcelRegister("7Dzg4", function(module, exports) {
module.exports = $58f786769412ee64$var$copy;
/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the source vector
 * @returns {vec3} out
 */ function $58f786769412ee64$var$copy(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}

});

parcelRegister("fo2vz", function(module, exports) {
module.exports = $b33b0affd8e8018b$var$set;
/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */ function $b33b0affd8e8018b$var$set(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}

});

parcelRegister("flAeI", function(module, exports) {
module.exports = $b2c4ecf49a9a9537$var$equals;

var $53wU4 = parcelRequire("53wU4");
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {vec3} a The first vector.
 * @param {vec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */ function $b2c4ecf49a9a9537$var$equals(a, b) {
    var a0 = a[0];
    var a1 = a[1];
    var a2 = a[2];
    var b0 = b[0];
    var b1 = b[1];
    var b2 = b[2];
    return Math.abs(a0 - b0) <= $53wU4 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $53wU4 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $53wU4 * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}

});

parcelRegister("gdjm5", function(module, exports) {
module.exports = $bcdcdfcd3dadb69e$var$exactEquals;
/**
 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
 *
 * @param {vec3} a The first vector.
 * @param {vec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */ function $bcdcdfcd3dadb69e$var$exactEquals(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}

});

parcelRegister("dT84A", function(module, exports) {
module.exports = $a1c6ac90cedabc45$var$add;
/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ function $a1c6ac90cedabc45$var$add(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}

});

parcelRegister("8tXPc", function(module, exports) {
module.exports = $62cf7021d039343b$var$subtract;
/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ function $62cf7021d039343b$var$subtract(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}

});

parcelRegister("eyNZt", function(module, exports) {

module.exports = (parcelRequire("8tXPc"));

});

parcelRegister("jIVHJ", function(module, exports) {
module.exports = $e5bee345176d314c$var$multiply;
/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ function $e5bee345176d314c$var$multiply(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}

});

parcelRegister("9hvp4", function(module, exports) {

module.exports = (parcelRequire("jIVHJ"));

});

parcelRegister("lKeja", function(module, exports) {
module.exports = $fd48fe2cc08a9e8a$var$divide;
/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ function $fd48fe2cc08a9e8a$var$divide(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}

});

parcelRegister("hzBGt", function(module, exports) {

module.exports = (parcelRequire("lKeja"));

});

parcelRegister("fFMqx", function(module, exports) {
module.exports = $b6903ff0abfdbd9f$var$min;
/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ function $b6903ff0abfdbd9f$var$min(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}

});

parcelRegister("OGbVP", function(module, exports) {
module.exports = $098565f814bb4b58$var$max;
/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ function $098565f814bb4b58$var$max(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}

});

parcelRegister("cNkpn", function(module, exports) {
module.exports = $9509e44a0757a6a2$var$floor;
/**
 * Math.floor the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to floor
 * @returns {vec3} out
 */ function $9509e44a0757a6a2$var$floor(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}

});

parcelRegister("3lT8n", function(module, exports) {
module.exports = $270e19b92c9e408f$var$ceil;
/**
 * Math.ceil the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to ceil
 * @returns {vec3} out
 */ function $270e19b92c9e408f$var$ceil(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}

});

parcelRegister("P7vHj", function(module, exports) {
module.exports = $099a96ea00a7e81d$var$round;
/**
 * Math.round the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to round
 * @returns {vec3} out
 */ function $099a96ea00a7e81d$var$round(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}

});

parcelRegister("82AuC", function(module, exports) {
module.exports = $5daad1579ab3af07$var$scale;
/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */ function $5daad1579ab3af07$var$scale(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}

});

parcelRegister("1fqWo", function(module, exports) {
module.exports = $0e8c17106d8e55ed$var$scaleAndAdd;
/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */ function $0e8c17106d8e55ed$var$scaleAndAdd(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}

});

parcelRegister("drpCB", function(module, exports) {
module.exports = $9c91abecc9b6d20d$var$distance;
/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} distance between a and b
 */ function $9c91abecc9b6d20d$var$distance(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2];
    return Math.sqrt(x * x + y * y + z * z);
}

});

parcelRegister("67O7B", function(module, exports) {

module.exports = (parcelRequire("drpCB"));

});

parcelRegister("2AKAe", function(module, exports) {
module.exports = $1e33140c8dc6b00e$var$squaredDistance;
/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} squared distance between a and b
 */ function $1e33140c8dc6b00e$var$squaredDistance(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2];
    return x * x + y * y + z * z;
}

});

parcelRegister("lQ4tv", function(module, exports) {

module.exports = (parcelRequire("2AKAe"));

});

parcelRegister("kzdQp", function(module, exports) {
module.exports = $ef91d0b2bf692e25$var$length;
/**
 * Calculates the length of a vec3
 *
 * @param {vec3} a vector to calculate length of
 * @returns {Number} length of a
 */ function $ef91d0b2bf692e25$var$length(a) {
    var x = a[0], y = a[1], z = a[2];
    return Math.sqrt(x * x + y * y + z * z);
}

});

parcelRegister("e23ro", function(module, exports) {

module.exports = (parcelRequire("kzdQp"));

});

parcelRegister("7MKk8", function(module, exports) {
module.exports = $5ab0f30cbad96e6c$var$squaredLength;
/**
 * Calculates the squared length of a vec3
 *
 * @param {vec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */ function $5ab0f30cbad96e6c$var$squaredLength(a) {
    var x = a[0], y = a[1], z = a[2];
    return x * x + y * y + z * z;
}

});

parcelRegister("2478D", function(module, exports) {

module.exports = (parcelRequire("7MKk8"));

});

parcelRegister("du2VM", function(module, exports) {
module.exports = $9d1059b9d2ee70c2$var$negate;
/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to negate
 * @returns {vec3} out
 */ function $9d1059b9d2ee70c2$var$negate(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}

});

parcelRegister("9rLgR", function(module, exports) {
module.exports = $6e0b4db50de11f82$var$inverse;
/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to invert
 * @returns {vec3} out
 */ function $6e0b4db50de11f82$var$inverse(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}

});

parcelRegister("4lH5K", function(module, exports) {
module.exports = $32aa8caf28ca1f31$var$cross;
/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ function $32aa8caf28ca1f31$var$cross(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}

});

parcelRegister("63k4I", function(module, exports) {
module.exports = $468298600ab8ea88$var$lerp;
/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec3} out
 */ function $468298600ab8ea88$var$lerp(out, a, b, t) {
    var ax = a[0], ay = a[1], az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}

});

parcelRegister("8F3Kv", function(module, exports) {
module.exports = $64e50f8e1ddecf95$var$random;
/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec3} out
 */ function $64e50f8e1ddecf95$var$random(out, scale) {
    scale = scale || 1.0;
    var r = Math.random() * 2.0 * Math.PI;
    var z = Math.random() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}

});

parcelRegister("iHSWE", function(module, exports) {
module.exports = $d9e6dd1578438d91$var$transformMat4;
/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec3} out
 */ function $d9e6dd1578438d91$var$transformMat4(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}

});

parcelRegister("9r5j4", function(module, exports) {
module.exports = $6deac076a80cb27a$var$transformMat3;
/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {mat4} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */ function $6deac076a80cb27a$var$transformMat3(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}

});

parcelRegister("ZsAhZ", function(module, exports) {
module.exports = $0b8bdede5a2dbe43$var$transformQuat;
/**
 * Transforms the vec3 with a quat
 *
 * Note: the quaternion must be a unit quaternion (|q| = 1) in
 * order for this operation to be valid.
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {quat} q unit quaternion to transform with
 * @returns {vec3} out
 */ function $0b8bdede5a2dbe43$var$transformQuat(out, a, q) {
    // Fast Vector Rotation using Quaternions by Robert Eisele
    // https://raw.org/proof/vector-rotation-using-quaternions/
    var x = a[0], y = a[1], z = a[2], qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    // t = q x v
    var tx = qy * z - qz * y;
    var ty = qz * x - qx * z;
    var tz = qx * y - qy * x;
    // t = 2t
    tx *= 2;
    ty *= 2;
    tz *= 2;
    // v + w t + q x t
    out[0] = x + qw * tx + qy * tz - qz * ty;
    out[1] = y + qw * ty + qz * tx - qx * tz;
    out[2] = z + qw * tz + qx * ty - qy * tx;
    return out;
}

});

parcelRegister("cUuOz", function(module, exports) {
module.exports = $96629e29d0d9a028$var$rotateX;
/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */ function $96629e29d0d9a028$var$rotateX(out, a, b, c) {
    var by = b[1];
    var bz = b[2];
    // Translate point to the origin
    var py = a[1] - by;
    var pz = a[2] - bz;
    var sc = Math.sin(c);
    var cc = Math.cos(c);
    // perform rotation and translate to correct position
    out[0] = a[0];
    out[1] = by + py * cc - pz * sc;
    out[2] = bz + py * sc + pz * cc;
    return out;
}

});

parcelRegister("EIxCF", function(module, exports) {
module.exports = $07a6498425737282$var$rotateY;
/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */ function $07a6498425737282$var$rotateY(out, a, b, c) {
    var bx = b[0];
    var bz = b[2];
    // translate point to the origin
    var px = a[0] - bx;
    var pz = a[2] - bz;
    var sc = Math.sin(c);
    var cc = Math.cos(c);
    // perform rotation and translate to correct position
    out[0] = bx + pz * sc + px * cc;
    out[1] = a[1];
    out[2] = bz + pz * cc - px * sc;
    return out;
}

});

parcelRegister("ca2yO", function(module, exports) {
module.exports = $8da867a5216a45a0$var$rotateZ;
/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */ function $8da867a5216a45a0$var$rotateZ(out, a, b, c) {
    var bx = b[0];
    var by = b[1];
    //Translate point to the origin
    var px = a[0] - bx;
    var py = a[1] - by;
    var sc = Math.sin(c);
    var cc = Math.cos(c);
    // perform rotation and translate to correct position
    out[0] = bx + px * cc - py * sc;
    out[1] = by + px * sc + py * cc;
    out[2] = a[2];
    return out;
}

});

parcelRegister("8s57t", function(module, exports) {
module.exports = $6274e8dff8f40cf9$var$forEach;

var $6274e8dff8f40cf9$var$vec = (parcelRequire("czATl"))();
/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */ function $6274e8dff8f40cf9$var$forEach(a, stride, offset, count, fn, arg) {
    var i, l;
    if (!stride) stride = 3;
    if (!offset) offset = 0;
    if (count) l = Math.min(count * stride + offset, a.length);
    else l = a.length;
    for(i = offset; i < l; i += stride){
        $6274e8dff8f40cf9$var$vec[0] = a[i];
        $6274e8dff8f40cf9$var$vec[1] = a[i + 1];
        $6274e8dff8f40cf9$var$vec[2] = a[i + 2];
        fn($6274e8dff8f40cf9$var$vec, $6274e8dff8f40cf9$var$vec, arg);
        a[i] = $6274e8dff8f40cf9$var$vec[0];
        a[i + 1] = $6274e8dff8f40cf9$var$vec[1];
        a[i + 2] = $6274e8dff8f40cf9$var$vec[2];
    }
    return a;
}

});

parcelRegister("9njAL", function(module, exports) {
module.exports = 0.000001;

});

parcelRegister("5zrC4", function(module, exports) {
module.exports = $40e5a4077625e196$var$create;
/**
 * Creates a new, empty vec2
 *
 * @returns {vec2} a new 2D vector
 */ function $40e5a4077625e196$var$create() {
    var out = new Float32Array(2);
    out[0] = 0;
    out[1] = 0;
    return out;
}

});

parcelRegister("dR9K4", function(module, exports) {
module.exports = $a167c827b64295a9$var$clone;
/**
 * Creates a new vec2 initialized with values from an existing vector
 *
 * @param {vec2} a vector to clone
 * @returns {vec2} a new 2D vector
 */ function $a167c827b64295a9$var$clone(a) {
    var out = new Float32Array(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}

});

parcelRegister("8U8Cj", function(module, exports) {
module.exports = $67ba3cd13e56c327$var$fromValues;
/**
 * Creates a new vec2 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} a new 2D vector
 */ function $67ba3cd13e56c327$var$fromValues(x, y) {
    var out = new Float32Array(2);
    out[0] = x;
    out[1] = y;
    return out;
}

});

parcelRegister("152Ae", function(module, exports) {
module.exports = $0c9843156bb50d97$var$copy;
/**
 * Copy the values from one vec2 to another
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the source vector
 * @returns {vec2} out
 */ function $0c9843156bb50d97$var$copy(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}

});

parcelRegister("041RP", function(module, exports) {
module.exports = $00c1d29e9d7428a2$var$set;
/**
 * Set the components of a vec2 to the given values
 *
 * @param {vec2} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} out
 */ function $00c1d29e9d7428a2$var$set(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}

});

parcelRegister("lUZQ8", function(module, exports) {
module.exports = $ff4ecc0d46bea851$var$equals;

var $9njAL = parcelRequire("9njAL");
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {vec2} a The first vector.
 * @param {vec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */ function $ff4ecc0d46bea851$var$equals(a, b) {
    var a0 = a[0];
    var a1 = a[1];
    var b0 = b[0];
    var b1 = b[1];
    return Math.abs(a0 - b0) <= $9njAL * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $9njAL * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}

});

parcelRegister("8PEWi", function(module, exports) {
module.exports = $66e2d7db2b0f1f5d$var$exactEquals;
/**
 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
 *
 * @param {vec2} a The first vector.
 * @param {vec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */ function $66e2d7db2b0f1f5d$var$exactEquals(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}

});

parcelRegister("7eHKC", function(module, exports) {
module.exports = $544bc73aa3f0efac$var$add;
/**
 * Adds two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ function $544bc73aa3f0efac$var$add(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}

});

parcelRegister("a405i", function(module, exports) {
module.exports = $753a57dd4ab7f073$var$subtract;
/**
 * Subtracts vector b from vector a
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ function $753a57dd4ab7f073$var$subtract(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}

});

parcelRegister("bHEVu", function(module, exports) {

module.exports = (parcelRequire("a405i"));

});

parcelRegister("0SrjJ", function(module, exports) {
module.exports = $002a3ac5d4594eb7$var$multiply;
/**
 * Multiplies two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ function $002a3ac5d4594eb7$var$multiply(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}

});

parcelRegister("igZDQ", function(module, exports) {

module.exports = (parcelRequire("0SrjJ"));

});

parcelRegister("l77rB", function(module, exports) {
module.exports = $f5f006ac1ab72943$var$divide;
/**
 * Divides two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ function $f5f006ac1ab72943$var$divide(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}

});

parcelRegister("bQw8f", function(module, exports) {

module.exports = (parcelRequire("l77rB"));

});

parcelRegister("2Qbdf", function(module, exports) {
module.exports = $211922b6140af408$var$inverse;
/**
 * Returns the inverse of the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to invert
 * @returns {vec2} out
 */ function $211922b6140af408$var$inverse(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}

});

parcelRegister("cXe0w", function(module, exports) {
module.exports = $96e5dc549ce5e279$var$min;
/**
 * Returns the minimum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ function $96e5dc549ce5e279$var$min(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}

});

parcelRegister("lRmZn", function(module, exports) {
module.exports = $fea061565c0200f5$var$max;
/**
 * Returns the maximum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ function $fea061565c0200f5$var$max(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}

});

parcelRegister("gloPU", function(module, exports) {
module.exports = $be61df7950380bb7$var$rotate;
/**
 * Rotates a vec2 by an angle
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to rotate
 * @param {Number} angle the angle of rotation (in radians)
 * @returns {vec2} out
 */ function $be61df7950380bb7$var$rotate(out, a, angle) {
    var c = Math.cos(angle), s = Math.sin(angle);
    var x = a[0], y = a[1];
    out[0] = x * c - y * s;
    out[1] = x * s + y * c;
    return out;
}

});

parcelRegister("3IGrR", function(module, exports) {
module.exports = $2b56688360765716$var$floor;
/**
 * Math.floor the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to floor
 * @returns {vec2} out
 */ function $2b56688360765716$var$floor(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}

});

parcelRegister("87XTH", function(module, exports) {
module.exports = $5ead708ed5695dad$var$ceil;
/**
 * Math.ceil the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to ceil
 * @returns {vec2} out
 */ function $5ead708ed5695dad$var$ceil(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}

});

parcelRegister("8bnXh", function(module, exports) {
module.exports = $5f51eed1655cdc02$var$round;
/**
 * Math.round the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to round
 * @returns {vec2} out
 */ function $5f51eed1655cdc02$var$round(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}

});

parcelRegister("io4QD", function(module, exports) {
module.exports = $d62e3a9807f52f99$var$scale;
/**
 * Scales a vec2 by a scalar number
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec2} out
 */ function $d62e3a9807f52f99$var$scale(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}

});

parcelRegister("8EqqX", function(module, exports) {
module.exports = $64c69058916c4be6$var$scaleAndAdd;
/**
 * Adds two vec2's after scaling the second operand by a scalar value
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec2} out
 */ function $64c69058916c4be6$var$scaleAndAdd(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}

});

parcelRegister("bsKoO", function(module, exports) {
module.exports = $85864d2a78141f5b$var$distance;
/**
 * Calculates the euclidian distance between two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} distance between a and b
 */ function $85864d2a78141f5b$var$distance(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.sqrt(x * x + y * y);
}

});

parcelRegister("hekff", function(module, exports) {

module.exports = (parcelRequire("bsKoO"));

});

parcelRegister("9RPI2", function(module, exports) {
module.exports = $72f12cb2cdabd2d0$var$squaredDistance;
/**
 * Calculates the squared euclidian distance between two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} squared distance between a and b
 */ function $72f12cb2cdabd2d0$var$squaredDistance(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}

});

parcelRegister("5myqE", function(module, exports) {

module.exports = (parcelRequire("9RPI2"));

});

parcelRegister("8UVmo", function(module, exports) {
module.exports = $67e00c38b14c8199$var$length;
/**
 * Calculates the length of a vec2
 *
 * @param {vec2} a vector to calculate length of
 * @returns {Number} length of a
 */ function $67e00c38b14c8199$var$length(a) {
    var x = a[0], y = a[1];
    return Math.sqrt(x * x + y * y);
}

});

parcelRegister("dXBRe", function(module, exports) {

module.exports = (parcelRequire("8UVmo"));

});

parcelRegister("6oVsU", function(module, exports) {
module.exports = $4a918f6145327445$var$squaredLength;
/**
 * Calculates the squared length of a vec2
 *
 * @param {vec2} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */ function $4a918f6145327445$var$squaredLength(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}

});

parcelRegister("3joeB", function(module, exports) {

module.exports = (parcelRequire("6oVsU"));

});

parcelRegister("1Vwt1", function(module, exports) {
module.exports = $16744ca0e50fdab1$var$negate;
/**
 * Negates the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to negate
 * @returns {vec2} out
 */ function $16744ca0e50fdab1$var$negate(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}

});

parcelRegister("l733a", function(module, exports) {
module.exports = $f5ec9e1a1ed17c6d$var$normalize;
/**
 * Normalize a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to normalize
 * @returns {vec2} out
 */ function $f5ec9e1a1ed17c6d$var$normalize(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
    }
    return out;
}

});

parcelRegister("28Qg1", function(module, exports) {
module.exports = $18f4dd59e6b1faf3$var$dot;
/**
 * Calculates the dot product of two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} dot product of a and b
 */ function $18f4dd59e6b1faf3$var$dot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}

});

parcelRegister("fPhZb", function(module, exports) {
module.exports = $b85992103ad4eaa6$var$cross;
/**
 * Computes the cross product of two vec2's
 * Note that the cross product must by definition produce a 3D vector
 *
 * @param {vec3} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec3} out
 */ function $b85992103ad4eaa6$var$cross(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}

});

parcelRegister("hUlg3", function(module, exports) {
module.exports = $d09827fdbf36b839$var$lerp;
/**
 * Performs a linear interpolation between two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec2} out
 */ function $d09827fdbf36b839$var$lerp(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}

});

parcelRegister("5bERg", function(module, exports) {
module.exports = $3c6dac697a38ec35$var$random;
/**
 * Generates a random vector with the given scale
 *
 * @param {vec2} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec2} out
 */ function $3c6dac697a38ec35$var$random(out, scale) {
    scale = scale || 1.0;
    var r = Math.random() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}

});

parcelRegister("iUq16", function(module, exports) {
module.exports = $dc41a35bfdcc554b$var$transformMat2;
/**
 * Transforms the vec2 with a mat2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat2} m matrix to transform with
 * @returns {vec2} out
 */ function $dc41a35bfdcc554b$var$transformMat2(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}

});

parcelRegister("fsO2G", function(module, exports) {
module.exports = $b42049e9ce8b58f2$var$transformMat2d;
/**
 * Transforms the vec2 with a mat2d
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat2d} m matrix to transform with
 * @returns {vec2} out
 */ function $b42049e9ce8b58f2$var$transformMat2d(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}

});

parcelRegister("ajhCe", function(module, exports) {
module.exports = $781957d61d697a69$var$transformMat3;
/**
 * Transforms the vec2 with a mat3
 * 3rd vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat3} m matrix to transform with
 * @returns {vec2} out
 */ function $781957d61d697a69$var$transformMat3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}

});

parcelRegister("4bW1U", function(module, exports) {
module.exports = $30d533fced5cd24b$var$transformMat4;
/**
 * Transforms the vec2 with a mat4
 * 3rd vector component is implicitly '0'
 * 4th vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec2} out
 */ function $30d533fced5cd24b$var$transformMat4(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}

});

parcelRegister("6SlJ8", function(module, exports) {
module.exports = $5018a3b9c9c6695c$var$forEach;

var $5018a3b9c9c6695c$var$vec = (parcelRequire("5zrC4"))();
/**
 * Perform some operation over an array of vec2s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec2. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec2s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */ function $5018a3b9c9c6695c$var$forEach(a, stride, offset, count, fn, arg) {
    var i, l;
    if (!stride) stride = 2;
    if (!offset) offset = 0;
    if (count) l = Math.min(count * stride + offset, a.length);
    else l = a.length;
    for(i = offset; i < l; i += stride){
        $5018a3b9c9c6695c$var$vec[0] = a[i];
        $5018a3b9c9c6695c$var$vec[1] = a[i + 1];
        fn($5018a3b9c9c6695c$var$vec, $5018a3b9c9c6695c$var$vec, arg);
        a[i] = $5018a3b9c9c6695c$var$vec[0];
        a[i + 1] = $5018a3b9c9c6695c$var$vec[1];
    }
    return a;
}

});

parcelRegister("1icGa", function(module, exports) {
module.exports = $0f114eb5dd6c26b7$var$limit;
/**
 * Limit the magnitude of this vector to the value used for the `max`
 * parameter.
 *
 * @param  {vec2} the vector to limit
 * @param  {Number} max the maximum magnitude for the vector
 * @returns {vec2} out
 */ function $0f114eb5dd6c26b7$var$limit(out, a, max) {
    var mSq = a[0] * a[0] + a[1] * a[1];
    if (mSq > max * max) {
        var n = Math.sqrt(mSq);
        out[0] = a[0] / n * max;
        out[1] = a[1] / n * max;
    } else {
        out[0] = a[0];
        out[1] = a[1];
    }
    return out;
}

});

parcelRegister("5UFnH", function(module, exports) {

var $g7kWO = parcelRequire("g7kWO");

var $8coUR = parcelRequire("8coUR");

var $auZlB = parcelRequire("auZlB");

var $ikIaj = parcelRequire("ikIaj");

var $gNfAP = parcelRequire("gNfAP");

var $dT84A = parcelRequire("dT84A");
module.exports = function cameraPerspective(opt) {
    opt = opt || {};
    var camera = $g7kWO(opt);
    camera.fov = $auZlB(opt.fov, Math.PI / 4);
    camera.near = $auZlB(opt.near, 1);
    camera.far = $auZlB(opt.far, 100);
    var center = [
        0,
        0,
        0
    ];
    var updateCombined = camera.update;
    function update() {
        var aspect = camera.viewport[2] / camera.viewport[3];
        // build projection matrix
        $ikIaj(camera.projection, camera.fov, aspect, Math.abs(camera.near), Math.abs(camera.far));
        // build view matrix
        $dT84A(center, camera.position, camera.direction);
        $gNfAP(camera.view, camera.position, center, camera.up);
        // update projection * view and invert
        updateCombined();
        return camera;
    }
    // set it up initially from constructor options
    update();
    return $8coUR(camera, {
        update: update
    });
};

});
parcelRegister("g7kWO", function(module, exports) {

var $8coUR = parcelRequire("8coUR");

var $jmgXs = parcelRequire("jmgXs");

var $8dkvo = parcelRequire("8dkvo");

var $jyn2k = parcelRequire("jyn2k");

var $2zrIh = parcelRequire("2zrIh");

var $63Mdu = parcelRequire("63Mdu");

var $dT84A = parcelRequire("dT84A");

var $1m04l = parcelRequire("1m04l");

var $i9qJL = parcelRequire("i9qJL");

var $8z9vI = parcelRequire("8z9vI");

var $fo2vz = parcelRequire("fo2vz");
// this could also be useful for a orthographic camera
module.exports = function cameraBase(opt) {
    opt = opt || {};
    var camera = {
        projection: $8z9vI([]),
        view: $8z9vI([]),
        position: opt.position || [
            0,
            0,
            0
        ],
        direction: opt.direction || [
            0,
            0,
            -1
        ],
        up: opt.up || [
            0,
            1,
            0
        ],
        viewport: opt.viewport || [
            -1,
            -1,
            1,
            1
        ],
        projView: $8z9vI([]),
        invProjView: $8z9vI([])
    };
    function update() {
        $1m04l(camera.projView, camera.projection, camera.view);
        var valid = $i9qJL(camera.invProjView, camera.projView);
        if (!valid) throw new Error('camera projection * view is non-invertible');
    }
    function lookAt(target) {
        $2zrIh(camera.direction, camera.up, camera.position, target);
        return camera;
    }
    function identity() {
        $fo2vz(camera.position, 0, 0, 0);
        $fo2vz(camera.direction, 0, 0, -1);
        $fo2vz(camera.up, 0, 1, 0);
        $8z9vI(camera.view);
        $8z9vI(camera.projection);
        $8z9vI(camera.projView);
        $8z9vI(camera.invProjView);
        return camera;
    }
    function translate(vec) {
        $dT84A(camera.position, camera.position, vec);
        return camera;
    }
    function createPickingRay(mouse) {
        var ray = new $jmgXs();
        $63Mdu(ray.origin, ray.direction, mouse, camera.viewport, camera.invProjView);
        return ray;
    }
    function project(point) {
        return $8dkvo([], point, camera.viewport, camera.projView);
    }
    function unproject(point) {
        return $jyn2k([], point, camera.viewport, camera.invProjView);
    }
    return $8coUR(camera, {
        translate: translate,
        identity: identity,
        lookAt: lookAt,
        createPickingRay: createPickingRay,
        update: update,
        project: project,
        unproject: unproject
    });
};

});
parcelRegister("8coUR", function(module, exports) {
'use strict';
function $5f82c58e3d599bd6$var$ToObject(val) {
    if (val == null) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
module.exports = Object.assign || function(target, source) {
    var from;
    var keys;
    var to = $5f82c58e3d599bd6$var$ToObject(target);
    for(var s = 1; s < arguments.length; s++){
        from = arguments[s];
        keys = Object.keys(Object(from));
        for(var i = 0; i < keys.length; i++)to[keys[i]] = from[keys[i]];
    }
    return to;
};

});

parcelRegister("jmgXs", function(module, exports) {

var $4yX4d = parcelRequire("4yX4d");

var $lVMZd = parcelRequire("lVMZd");

var $ivsrN = parcelRequire("ivsrN");

var $h6vGF = parcelRequire("h6vGF");

var $7Dzg4 = parcelRequire("7Dzg4");
var $e17d39e1ab4f700d$var$tmpTriangle = [
    [
        0,
        0,
        0
    ],
    [
        0,
        0,
        0
    ],
    [
        0,
        0,
        0
    ]
];
var $e17d39e1ab4f700d$var$tmp3 = [
    0,
    0,
    0
];
module.exports = $e17d39e1ab4f700d$var$Ray;
function $e17d39e1ab4f700d$var$Ray(origin, direction) {
    this.origin = origin || [
        0,
        0,
        0
    ];
    this.direction = direction || [
        0,
        0,
        -1
    ];
}
$e17d39e1ab4f700d$var$Ray.prototype.set = function(origin, direction) {
    this.origin = origin;
    this.direction = direction;
};
$e17d39e1ab4f700d$var$Ray.prototype.copy = function(other) {
    $7Dzg4(this.origin, other.origin);
    $7Dzg4(this.direction, other.direction);
};
$e17d39e1ab4f700d$var$Ray.prototype.clone = function() {
    var other = new $e17d39e1ab4f700d$var$Ray();
    other.copy(this);
    return other;
};
$e17d39e1ab4f700d$var$Ray.prototype.intersectsSphere = function(center, radius) {
    return $ivsrN($e17d39e1ab4f700d$var$tmp3, this.origin, this.direction, center, radius);
};
$e17d39e1ab4f700d$var$Ray.prototype.intersectsPlane = function(normal, distance) {
    return $lVMZd($e17d39e1ab4f700d$var$tmp3, this.origin, this.direction, normal, distance);
};
$e17d39e1ab4f700d$var$Ray.prototype.intersectsTriangle = function(triangle) {
    return $4yX4d($e17d39e1ab4f700d$var$tmp3, this.origin, this.direction, triangle);
};
$e17d39e1ab4f700d$var$Ray.prototype.intersectsBox = function(aabb) {
    return $h6vGF($e17d39e1ab4f700d$var$tmp3, this.origin, this.direction, aabb);
};
$e17d39e1ab4f700d$var$Ray.prototype.intersectsTriangleCell = function(cell, positions) {
    var a = cell[0], b = cell[1], c = cell[2];
    $e17d39e1ab4f700d$var$tmpTriangle[0] = positions[a];
    $e17d39e1ab4f700d$var$tmpTriangle[1] = positions[b];
    $e17d39e1ab4f700d$var$tmpTriangle[2] = positions[c];
    return this.intersectsTriangle($e17d39e1ab4f700d$var$tmpTriangle);
};

});
parcelRegister("4yX4d", function(module, exports) {

var $4lH5K = parcelRequire("4lH5K");

var $a5Tdg = parcelRequire("a5Tdg");

var $8tXPc = parcelRequire("8tXPc");
var $352827e610dfed07$var$EPSILON = 0.000001;
var $352827e610dfed07$var$edge1 = [
    0,
    0,
    0
];
var $352827e610dfed07$var$edge2 = [
    0,
    0,
    0
];
var $352827e610dfed07$var$tvec = [
    0,
    0,
    0
];
var $352827e610dfed07$var$pvec = [
    0,
    0,
    0
];
var $352827e610dfed07$var$qvec = [
    0,
    0,
    0
];
module.exports = $352827e610dfed07$var$intersectTriangle;
function $352827e610dfed07$var$intersectTriangle(out, pt, dir, tri) {
    $8tXPc($352827e610dfed07$var$edge1, tri[1], tri[0]);
    $8tXPc($352827e610dfed07$var$edge2, tri[2], tri[0]);
    $4lH5K($352827e610dfed07$var$pvec, dir, $352827e610dfed07$var$edge2);
    var det = $a5Tdg($352827e610dfed07$var$edge1, $352827e610dfed07$var$pvec);
    if (det < $352827e610dfed07$var$EPSILON) return null;
    $8tXPc($352827e610dfed07$var$tvec, pt, tri[0]);
    var u = $a5Tdg($352827e610dfed07$var$tvec, $352827e610dfed07$var$pvec);
    if (u < 0 || u > det) return null;
    $4lH5K($352827e610dfed07$var$qvec, $352827e610dfed07$var$tvec, $352827e610dfed07$var$edge1);
    var v = $a5Tdg(dir, $352827e610dfed07$var$qvec);
    if (v < 0 || u + v > det) return null;
    var t = $a5Tdg($352827e610dfed07$var$edge2, $352827e610dfed07$var$qvec) / det;
    out[0] = pt[0] + t * dir[0];
    out[1] = pt[1] + t * dir[1];
    out[2] = pt[2] + t * dir[2];
    return out;
}

});

parcelRegister("lVMZd", function(module, exports) {

var $a5Tdg = parcelRequire("a5Tdg");

var $dT84A = parcelRequire("dT84A");

var $82AuC = parcelRequire("82AuC");

var $7Dzg4 = parcelRequire("7Dzg4");
module.exports = $ff74eb835d5701ea$var$intersectRayPlane;
var $ff74eb835d5701ea$var$v0 = [
    0,
    0,
    0
];
function $ff74eb835d5701ea$var$intersectRayPlane(out, origin, direction, normal, dist) {
    var denom = $a5Tdg(direction, normal);
    if (denom !== 0) {
        var t = -($a5Tdg(origin, normal) + dist) / denom;
        if (t < 0) return null;
        $82AuC($ff74eb835d5701ea$var$v0, direction, t);
        return $dT84A(out, origin, $ff74eb835d5701ea$var$v0);
    } else if ($a5Tdg(normal, origin) + dist === 0) return $7Dzg4(out, origin);
    else return null;
}

});

parcelRegister("ivsrN", function(module, exports) {

var $2AKAe = parcelRequire("2AKAe");

var $a5Tdg = parcelRequire("a5Tdg");

var $8tXPc = parcelRequire("8tXPc");

var $1fqWo = parcelRequire("1fqWo");

var $82AuC = parcelRequire("82AuC");

var $dT84A = parcelRequire("dT84A");
var $d79130453d4eee15$var$tmp = [
    0,
    0,
    0
];
module.exports = $d79130453d4eee15$var$intersectRaySphere;
function $d79130453d4eee15$var$intersectRaySphere(out, origin, direction, center, radius) {
    $8tXPc($d79130453d4eee15$var$tmp, center, origin);
    var len = $a5Tdg(direction, $d79130453d4eee15$var$tmp);
    if (len < 0) return null;
    $1fqWo($d79130453d4eee15$var$tmp, origin, direction, len);
    var dSq = $2AKAe(center, $d79130453d4eee15$var$tmp);
    var rSq = radius * radius;
    if (dSq > rSq) return null;
    $82AuC(out, direction, len - Math.sqrt(rSq - dSq));
    return $dT84A(out, out, origin);
}

});

parcelRegister("h6vGF", function(module, exports) {
module.exports = $c73b939d69021784$var$intersection;
module.exports.distance = $c73b939d69021784$var$distance;
function $c73b939d69021784$var$intersection(out, ro, rd, aabb) {
    var d = $c73b939d69021784$var$distance(ro, rd, aabb);
    if (d === Infinity) out = null;
    else {
        out = out || [];
        for(var i = 0; i < ro.length; i++)out[i] = ro[i] + rd[i] * d;
    }
    return out;
}
function $c73b939d69021784$var$distance(ro, rd, aabb) {
    var dims = ro.length;
    var lo = -Infinity;
    var hi = Infinity;
    for(var i = 0; i < dims; i++){
        var dimLo = (aabb[0][i] - ro[i]) / rd[i];
        var dimHi = (aabb[1][i] - ro[i]) / rd[i];
        if (dimLo > dimHi) {
            var tmp = dimLo;
            dimLo = dimHi;
            dimHi = tmp;
        }
        if (dimHi < lo || dimLo > hi) return Infinity;
        if (dimLo > lo) lo = dimLo;
        if (dimHi < hi) hi = dimHi;
    }
    return lo > hi ? Infinity : lo;
}

});


parcelRegister("8dkvo", function(module, exports) {

var $kUjcm = parcelRequire("kUjcm");

var $fFX3t = parcelRequire("fFX3t");
var $5faf7192f16df0b7$var$NEAR_RANGE = 0;
var $5faf7192f16df0b7$var$FAR_RANGE = 1;
var $5faf7192f16df0b7$var$tmp4 = [
    0,
    0,
    0,
    0
];
module.exports = $5faf7192f16df0b7$var$cameraProject;
function $5faf7192f16df0b7$var$cameraProject(out, vec, viewport, combinedProjView) {
    var vX = viewport[0], vY = viewport[1], vWidth = viewport[2], vHeight = viewport[3], n = $5faf7192f16df0b7$var$NEAR_RANGE, f = $5faf7192f16df0b7$var$FAR_RANGE;
    // convert: clip space -> NDC -> window coords
    // implicit 1.0 for w component
    $fFX3t($5faf7192f16df0b7$var$tmp4, vec[0], vec[1], vec[2], 1.0);
    // transform into clip space
    $kUjcm($5faf7192f16df0b7$var$tmp4, $5faf7192f16df0b7$var$tmp4, combinedProjView);
    // now transform into NDC
    var w = $5faf7192f16df0b7$var$tmp4[3];
    if (w !== 0) {
        $5faf7192f16df0b7$var$tmp4[0] = $5faf7192f16df0b7$var$tmp4[0] / w;
        $5faf7192f16df0b7$var$tmp4[1] = $5faf7192f16df0b7$var$tmp4[1] / w;
        $5faf7192f16df0b7$var$tmp4[2] = $5faf7192f16df0b7$var$tmp4[2] / w;
    }
    // and finally into window coordinates
    // the foruth component is (1/clip.w)
    // which is the same as gl_FragCoord.w
    out[0] = vX + vWidth / 2 * $5faf7192f16df0b7$var$tmp4[0] + (0 + vWidth / 2);
    out[1] = vY + vHeight / 2 * $5faf7192f16df0b7$var$tmp4[1] + (0 + vHeight / 2);
    out[2] = (f - n) / 2 * $5faf7192f16df0b7$var$tmp4[2] + (f + n) / 2;
    out[3] = w === 0 ? 0 : 1 / w;
    return out;
}

});
parcelRegister("kUjcm", function(module, exports) {
module.exports = $f387edfb9498f9f7$var$transformMat4;
/**
 * Transforms the vec4 with a mat4.
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec4} out
 */ function $f387edfb9498f9f7$var$transformMat4(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}

});

parcelRegister("fFX3t", function(module, exports) {
module.exports = $b6987e6f4fd6b257$var$set;
/**
 * Set the components of a vec4 to the given values
 *
 * @param {vec4} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} out
 */ function $b6987e6f4fd6b257$var$set(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}

});


parcelRegister("jyn2k", function(module, exports) {

var $2pDjR = parcelRequire("2pDjR");
module.exports = $e3c30fda99215ce0$var$unproject;
/**
 * Unproject a point from screen space to 3D space.
 * The point should have its x and y properties set to
 * 2D screen space, and the z either at 0 (near plane)
 * or 1 (far plane). The provided matrix is assumed to already
 * be combined, i.e. projection * view.
 *
 * After this operation, the out vector's [x, y, z] components will
 * represent the unprojected 3D coordinate.
 *
 * @param  {vec3} out               the output vector
 * @param  {vec3} vec               the 2D space vector to unproject
 * @param  {vec4} viewport          screen x, y, width and height in pixels
 * @param  {mat4} invProjectionView combined projection and view matrix
 * @return {vec3}                   the output vector
 */ function $e3c30fda99215ce0$var$unproject(out, vec, viewport, invProjectionView) {
    var viewX = viewport[0], viewY = viewport[1], viewWidth = viewport[2], viewHeight = viewport[3];
    var x = vec[0], y = vec[1], z = vec[2];
    x = x - viewX;
    y = viewHeight - y - 1;
    y = y - viewY;
    out[0] = 2 * x / viewWidth - 1;
    out[1] = 2 * y / viewHeight - 1;
    out[2] = 2 * z - 1;
    return $2pDjR(out, out, invProjectionView);
}

});
parcelRegister("2pDjR", function(module, exports) {
module.exports = $1c1c6a943f307004$var$project;
/**
 * Multiplies the input vec by the specified matrix, 
 * applying a W divide, and stores the result in out 
 * vector. This is useful for projection,
 * e.g. unprojecting a 2D point into 3D space.
 *
 * @method  prj
 * @param {vec3} out the output vector
 * @param {vec3} vec the input vector to project
 * @param {mat4} m the 4x4 matrix to multiply with 
 * @return {vec3} the out vector
 */ function $1c1c6a943f307004$var$project(out, vec, m) {
    var x = vec[0], y = vec[1], z = vec[2], a00 = m[0], a01 = m[1], a02 = m[2], a03 = m[3], a10 = m[4], a11 = m[5], a12 = m[6], a13 = m[7], a20 = m[8], a21 = m[9], a22 = m[10], a23 = m[11], a30 = m[12], a31 = m[13], a32 = m[14], a33 = m[15];
    var lw = 1 / (x * a03 + y * a13 + z * a23 + a33);
    out[0] = (x * a00 + y * a10 + z * a20 + a30) * lw;
    out[1] = (x * a01 + y * a11 + z * a21 + a31) * lw;
    out[2] = (x * a02 + y * a12 + z * a22 + a32) * lw;
    return out;
}

});


parcelRegister("2zrIh", function(module, exports) {
// could be modularized...

var $4lH5K = parcelRequire("4lH5K");

var $8tXPc = parcelRequire("8tXPc");

var $dKsAX = parcelRequire("dKsAX");

var $7Dzg4 = parcelRequire("7Dzg4");

var $a5Tdg = parcelRequire("a5Tdg");

var $82AuC = parcelRequire("82AuC");
var $1df458f0949fde83$var$tmp = [
    0,
    0,
    0
];
var $1df458f0949fde83$var$epsilon = 0.000000001;
// modifies direction & up vectors in place
module.exports = function(direction, up, position, target) {
    $8tXPc($1df458f0949fde83$var$tmp, target, position);
    $dKsAX($1df458f0949fde83$var$tmp, $1df458f0949fde83$var$tmp);
    var isZero = $1df458f0949fde83$var$tmp[0] === 0 && $1df458f0949fde83$var$tmp[1] === 0 && $1df458f0949fde83$var$tmp[2] === 0;
    if (!isZero) {
        var d = $a5Tdg($1df458f0949fde83$var$tmp, up);
        if (Math.abs(d - 1) < $1df458f0949fde83$var$epsilon) $82AuC(up, direction, -1);
        else if (Math.abs(d + 1) < $1df458f0949fde83$var$epsilon) $7Dzg4(up, direction);
        $7Dzg4(direction, $1df458f0949fde83$var$tmp);
        // normalize up vector
        $4lH5K($1df458f0949fde83$var$tmp, direction, up);
        $dKsAX($1df458f0949fde83$var$tmp, $1df458f0949fde83$var$tmp);
        $4lH5K(up, $1df458f0949fde83$var$tmp, direction);
        $dKsAX(up, up);
    }
};

});

parcelRegister("63Mdu", function(module, exports) {

var $jyn2k = parcelRequire("jyn2k");

var $fo2vz = parcelRequire("fo2vz");

var $8tXPc = parcelRequire("8tXPc");

var $dKsAX = parcelRequire("dKsAX");
module.exports = $46986cb6ef09afa3$var$createPickRay;
function $46986cb6ef09afa3$var$createPickRay(origin, direction, point, viewport, invProjView) {
    $fo2vz(origin, point[0], point[1], 0);
    $fo2vz(direction, point[0], point[1], 1);
    $jyn2k(origin, origin, viewport, invProjView);
    $jyn2k(direction, direction, viewport, invProjView);
    $8tXPc(direction, direction, origin);
    $dKsAX(direction, direction);
}

});

parcelRegister("1m04l", function(module, exports) {
module.exports = $0fc7e63ef8d2acb8$var$multiply;
/**
 * Multiplies two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */ function $0fc7e63ef8d2acb8$var$multiply(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}

});

parcelRegister("i9qJL", function(module, exports) {
module.exports = $d36dceac448fd16e$var$invert;
/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */ function $d36dceac448fd16e$var$invert(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15], b00 = a00 * a11 - a01 * a10, b01 = a00 * a12 - a02 * a10, b02 = a00 * a13 - a03 * a10, b03 = a01 * a12 - a02 * a11, b04 = a01 * a13 - a03 * a11, b05 = a02 * a13 - a03 * a12, b06 = a20 * a31 - a21 * a30, b07 = a20 * a32 - a22 * a30, b08 = a20 * a33 - a23 * a30, b09 = a21 * a32 - a22 * a31, b10 = a21 * a33 - a23 * a31, b11 = a22 * a33 - a23 * a32, // Calculate the determinant
    det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}

});

parcelRegister("8z9vI", function(module, exports) {
module.exports = $63c8f8347e5b821b$var$identity;
/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */ function $63c8f8347e5b821b$var$identity(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

});


parcelRegister("auZlB", function(module, exports) {
'use strict';
module.exports = function defined() {
    for(var i = 0; i < arguments.length; i++){
        if (typeof arguments[i] !== 'undefined') return arguments[i];
    }
};

});

parcelRegister("ikIaj", function(module, exports) {
module.exports = $d58c5a9490c4aa87$var$perspective;
/**
 * Generates a perspective projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */ function $d58c5a9490c4aa87$var$perspective(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf = 1 / (near - far);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = 2 * far * near * nf;
    out[15] = 0;
    return out;
}

});

parcelRegister("gNfAP", function(module, exports) {

var $8z9vI = parcelRequire("8z9vI");
module.exports = $c39d516a9b7247fa$var$lookAt;
/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {vec3} eye Position of the viewer
 * @param {vec3} center Point the viewer is looking at
 * @param {vec3} up vec3 pointing up
 * @returns {mat4} out
 */ function $c39d516a9b7247fa$var$lookAt(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len, eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2], centerx = center[0], centery = center[1], centerz = center[2];
    if (Math.abs(eyex - centerx) < 0.000001 && Math.abs(eyey - centery) < 0.000001 && Math.abs(eyez - centerz) < 0.000001) return $8z9vI(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}

});


parcelRegister("fW4F6", function(module, exports) {
module.exports = $b99fe3917eae8d20$var$create;
/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */ function $b99fe3917eae8d20$var$create() {
    var out = new Float32Array(16);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

});

parcelRegister("iBqKq", function(module, exports) {
module.exports = $d8b06e3ae3f8626a$var$clone;
/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {mat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */ function $d8b06e3ae3f8626a$var$clone(a) {
    var out = new Float32Array(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}

});

parcelRegister("izCn0", function(module, exports) {
module.exports = $d8594262b46779fa$var$copy;
/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */ function $d8594262b46779fa$var$copy(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}

});

parcelRegister("8q2JF", function(module, exports) {
module.exports = $6212dfa7446f7b87$var$transpose;
/**
 * Transpose the values of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */ function $6212dfa7446f7b87$var$transpose(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3], a12 = a[6], a13 = a[7], a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}

});

parcelRegister("9VokK", function(module, exports) {
module.exports = $739c500fb09224b4$var$adjoint;
/**
 * Calculates the adjugate of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */ function $739c500fb09224b4$var$adjoint(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
}

});

parcelRegister("1GN8q", function(module, exports) {
module.exports = $13afd3e0bf5d9578$var$determinant;
/**
 * Calculates the determinant of a mat4
 *
 * @param {mat4} a the source matrix
 * @returns {Number} determinant of a
 */ function $13afd3e0bf5d9578$var$determinant(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15], b00 = a00 * a11 - a01 * a10, b01 = a00 * a12 - a02 * a10, b02 = a00 * a13 - a03 * a10, b03 = a01 * a12 - a02 * a11, b04 = a01 * a13 - a03 * a11, b05 = a02 * a13 - a03 * a12, b06 = a20 * a31 - a21 * a30, b07 = a20 * a32 - a22 * a30, b08 = a20 * a33 - a23 * a30, b09 = a21 * a32 - a22 * a31, b10 = a21 * a33 - a23 * a31, b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}

});

parcelRegister("kAYus", function(module, exports) {
module.exports = $efe61786f54a70f5$var$translate;
/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to translate
 * @param {vec3} v vector to translate by
 * @returns {mat4} out
 */ function $efe61786f54a70f5$var$translate(out, a, v) {
    var x = v[0], y = v[1], z = v[2], a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}

});

parcelRegister("9IQUq", function(module, exports) {
module.exports = $714143be6d3626de$var$scale;
/**
 * Scales the mat4 by the dimensions in the given vec3
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to scale
 * @param {vec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/ function $714143be6d3626de$var$scale(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}

});

parcelRegister("2HmzD", function(module, exports) {
module.exports = $1f711b99ce241a7b$var$rotate;
/**
 * Rotates a mat4 by the given angle
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {vec3} axis the axis to rotate around
 * @returns {mat4} out
 */ function $1f711b99ce241a7b$var$rotate(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2], len = Math.sqrt(x * x + y * y + z * z), s, c, t, a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23, b00, b01, b02, b10, b11, b12, b20, b21, b22;
    if (Math.abs(len) < 0.000001) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c;
    // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}

});

parcelRegister("cDXxV", function(module, exports) {
module.exports = $93475130fce129cb$var$rotateX;
/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ function $93475130fce129cb$var$rotateX(out, a, rad) {
    var s = Math.sin(rad), c = Math.cos(rad), a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    if (a !== out) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}

});

parcelRegister("9yOYc", function(module, exports) {
module.exports = $6f5ed39a362e5378$var$rotateY;
/**
 * Rotates a matrix by the given angle around the Y axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ function $6f5ed39a362e5378$var$rotateY(out, a, rad) {
    var s = Math.sin(rad), c = Math.cos(rad), a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    if (a !== out) {
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}

});

parcelRegister("jw0rw", function(module, exports) {
module.exports = $e3515969f632cae0$var$rotateZ;
/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ function $e3515969f632cae0$var$rotateZ(out, a, rad) {
    var s = Math.sin(rad), c = Math.cos(rad), a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    if (a !== out) {
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}

});

parcelRegister("grshU", function(module, exports) {
module.exports = $bf851c5c044a1993$var$fromRotation;
/**
 * Creates a matrix from a given angle around a given axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest)
 *     mat4.rotate(dest, dest, rad, axis)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @param {vec3} axis the axis to rotate around
 * @returns {mat4} out
 */ function $bf851c5c044a1993$var$fromRotation(out, rad, axis) {
    var s, c, t;
    var x = axis[0];
    var y = axis[1];
    var z = axis[2];
    var len = Math.sqrt(x * x + y * y + z * z);
    if (Math.abs(len) < 0.000001) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

});

parcelRegister("3dVn9", function(module, exports) {
module.exports = $258f16f7c3298a7f$var$fromRotationTranslation;
/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     var quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @returns {mat4} out
 */ function $258f16f7c3298a7f$var$fromRotationTranslation(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3], x2 = x + x, y2 = y + y, z2 = z + z, xx = x * x2, xy = x * y2, xz = x * z2, yy = y * y2, yz = y * z2, zz = z * z2, wx = w * x2, wy = w * y2, wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}

});

parcelRegister("aYB92", function(module, exports) {
module.exports = $7fdc522ca4228144$var$fromScaling;
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest)
 *     mat4.scale(dest, dest, vec)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {vec3} v Scaling vector
 * @returns {mat4} out
 */ function $7fdc522ca4228144$var$fromScaling(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

});

parcelRegister("3ugVX", function(module, exports) {
module.exports = $28a14f242d0861c3$var$fromTranslation;
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest)
 *     mat4.translate(dest, dest, vec)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {vec3} v Translation vector
 * @returns {mat4} out
 */ function $28a14f242d0861c3$var$fromTranslation(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}

});

parcelRegister("kxUBr", function(module, exports) {
module.exports = $ef52cbdec79a556f$var$fromXRotation;
/**
 * Creates a matrix from the given angle around the X axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest)
 *     mat4.rotateX(dest, dest, rad)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ function $ef52cbdec79a556f$var$fromXRotation(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

});

parcelRegister("9zaKy", function(module, exports) {
module.exports = $6f6fb89dd9b8f667$var$fromYRotation;
/**
 * Creates a matrix from the given angle around the Y axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest)
 *     mat4.rotateY(dest, dest, rad)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ function $6f6fb89dd9b8f667$var$fromYRotation(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

});

parcelRegister("9s3HV", function(module, exports) {
module.exports = $6e199acc3f2e2699$var$fromZRotation;
/**
 * Creates a matrix from the given angle around the Z axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest)
 *     mat4.rotateZ(dest, dest, rad)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ function $6e199acc3f2e2699$var$fromZRotation(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

});

parcelRegister("jPLYo", function(module, exports) {
module.exports = $e707fe3586a96eeb$var$fromQuat;
/**
 * Creates a matrix from a quaternion rotation.
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @returns {mat4} out
 */ function $e707fe3586a96eeb$var$fromQuat(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3], x2 = x + x, y2 = y + y, z2 = z + z, xx = x * x2, yx = y * x2, yy = y * y2, zx = z * x2, zy = z * y2, zz = z * z2, wx = w * x2, wy = w * y2, wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

});

parcelRegister("dkigV", function(module, exports) {
module.exports = $9b3b5110117f48d1$var$frustum;
/**
 * Generates a frustum matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Number} left Left bound of the frustum
 * @param {Number} right Right bound of the frustum
 * @param {Number} bottom Bottom bound of the frustum
 * @param {Number} top Top bound of the frustum
 * @param {Number} near Near bound of the frustum
 * @param {Number} far Far bound of the frustum
 * @returns {mat4} out
 */ function $9b3b5110117f48d1$var$frustum(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left), tb = 1 / (top - bottom), nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}

});

parcelRegister("5Aand", function(module, exports) {
module.exports = $41085c7d9994f00e$var$perspectiveFromFieldOfView;
/**
 * Generates a perspective projection matrix with the given field of view.
 * This is primarily useful for generating projection matrices to be used
 * with the still experiemental WebVR API.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fov Object containing the following values: upDegrees, downDegrees, leftDegrees, rightDegrees
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */ function $41085c7d9994f00e$var$perspectiveFromFieldOfView(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0), downTan = Math.tan(fov.downDegrees * Math.PI / 180.0), leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0), rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0), xScale = 2.0 / (leftTan + rightTan), yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}

});

parcelRegister("8yCJQ", function(module, exports) {
module.exports = $63af8c5f2339220d$var$ortho;
/**
 * Generates a orthogonal projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */ function $63af8c5f2339220d$var$ortho(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right), bt = 1 / (bottom - top), nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}

});

parcelRegister("9QbSM", function(module, exports) {
module.exports = $72a23007e9e60e98$var$str;
/**
 * Returns a string representation of a mat4
 *
 * @param {mat4} mat matrix to represent as a string
 * @returns {String} string representation of the matrix
 */ function $72a23007e9e60e98$var$str(a) {
    return 'mat4(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ', ' + a[4] + ', ' + a[5] + ', ' + a[6] + ', ' + a[7] + ', ' + a[8] + ', ' + a[9] + ', ' + a[10] + ', ' + a[11] + ', ' + a[12] + ', ' + a[13] + ', ' + a[14] + ', ' + a[15] + ')';
}

});

parcelRegister("3kW6u", function(module, exports) {

$parcel$export(module.exports, "nothing", () => NOTHING);
$parcel$export(module.exports, "immerable", () => DRAFTABLE);
$parcel$export(module.exports, "isDraft", () => isDraft);
$parcel$export(module.exports, "isDraftable", () => isDraftable);
$parcel$export(module.exports, "original", () => original);
$parcel$export(module.exports, "Immer", () => Immer);
$parcel$export(module.exports, "produce", () => produce);
$parcel$export(module.exports, "produceWithPatches", () => produceWithPatches);
$parcel$export(module.exports, "setAutoFreeze", () => setAutoFreeze);
$parcel$export(module.exports, "setUseProxies", () => setUseProxies);
$parcel$export(module.exports, "applyPatches", () => applyPatches$1);
$parcel$export(module.exports, "createDraft", () => createDraft);
$parcel$export(module.exports, "finishDraft", () => finishDraft);
$parcel$export(module.exports, "castDraft", () => castDraft);
$parcel$export(module.exports, "castImmutable", () => castImmutable);
$parcel$export(module.exports, "default", () => $26e04f88d18e3c01$export$2e2bcd8739ae039);
// Should be no imports here!
var _a; // SOme things that should be evaluated before all else...
var hasSymbol = typeof Symbol !== "undefined";
var hasMap = typeof Map !== "undefined";
var hasSet = typeof Set !== "undefined";
/**
 * The sentinel value returned by producers to replace the draft with undefined.
 */ var NOTHING = hasSymbol ? Symbol("immer-nothing") : (_a = {}, _a["immer-nothing"] = true, _a);
/**
 * To let Immer treat your class instances as plain immutable objects
 * (albeit with a custom prototype), you must define either an instance property
 * or a static property on each of your custom classes.
 *
 * Otherwise, your class instance will never be drafted, which means it won't be
 * safe to mutate in a produce callback.
 */ var DRAFTABLE = hasSymbol ? Symbol("immer-draftable") : "__$immer_draftable";
var DRAFT_STATE = hasSymbol ? Symbol("immer-state") : "__$immer_state";
var iteratorSymbol = hasSymbol ? Symbol.iterator : "@@iterator";
/* istanbul ignore next */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
}; // Ugly hack to resolve #502 and inherit built in Map / Set
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = (__.prototype = b.prototype, new __());
}
var Archtype;
(function(Archtype) {
    Archtype[Archtype["Object"] = 0] = "Object";
    Archtype[Archtype["Array"] = 1] = "Array";
    Archtype[Archtype["Map"] = 2] = "Map";
    Archtype[Archtype["Set"] = 3] = "Set";
})(Archtype || (Archtype = {}));
var ProxyType;
(function(ProxyType) {
    ProxyType[ProxyType["ProxyObject"] = 0] = "ProxyObject";
    ProxyType[ProxyType["ProxyArray"] = 1] = "ProxyArray";
    ProxyType[ProxyType["ES5Object"] = 2] = "ES5Object";
    ProxyType[ProxyType["ES5Array"] = 3] = "ES5Array";
    ProxyType[ProxyType["Map"] = 4] = "Map";
    ProxyType[ProxyType["Set"] = 5] = "Set";
})(ProxyType || (ProxyType = {}));
/** Returns true if the given value is an Immer draft */ function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
/** Returns true if the given value can be drafted by Immer */ function isDraftable(value) {
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!value.constructor[DRAFTABLE] || isMap(value) || isSet(value);
}
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    var proto = Object.getPrototypeOf(value);
    return !proto || proto === Object.prototype;
}
function original(value) {
    if (value && value[DRAFT_STATE]) return value[DRAFT_STATE].base;
     // otherwise return undefined
}
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : typeof Object.getOwnPropertySymbols !== "undefined" ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function each(obj, iter) {
    if (getArchtype(obj) === Archtype.Object) ownKeys(obj).forEach(function(key) {
        return iter(key, obj[key], obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function isEnumerable(base, prop) {
    var desc = Object.getOwnPropertyDescriptor(base, prop);
    return desc && desc.enumerable ? true : false;
}
function getArchtype(thing) {
    /* istanbul ignore next */ if (!thing) die();
    if (thing[DRAFT_STATE]) switch(thing[DRAFT_STATE].type){
        case ProxyType.ES5Object:
        case ProxyType.ProxyObject:
            return Archtype.Object;
        case ProxyType.ES5Array:
        case ProxyType.ProxyArray:
            return Archtype.Array;
        case ProxyType.Map:
            return Archtype.Map;
        case ProxyType.Set:
            return Archtype.Set;
    }
    return Array.isArray(thing) ? Archtype.Array : isMap(thing) ? Archtype.Map : isSet(thing) ? Archtype.Set : Archtype.Object;
}
function has(thing, prop) {
    return getArchtype(thing) === Archtype.Map ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    // @ts-ignore
    return getArchtype(thing) === Archtype.Map ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    switch(getArchtype(thing)){
        case Archtype.Map:
            thing.set(propOrOldValue, value);
            break;
        case Archtype.Set:
            thing.delete(propOrOldValue);
            thing.add(value);
            break;
        default:
            thing[propOrOldValue] = value;
    }
}
function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return hasMap && target instanceof Map;
}
function isSet(target) {
    return hasSet && target instanceof Set;
}
function latest(state) {
    return state.copy || state.base;
}
function shallowCopy(base, invokeGetters) {
    if (invokeGetters === void 0) invokeGetters = false;
    if (Array.isArray(base)) return base.slice();
    var clone = Object.create(Object.getPrototypeOf(base));
    ownKeys(base).forEach(function(key) {
        if (key === DRAFT_STATE) return; // Never copy over draft state.
        var desc = Object.getOwnPropertyDescriptor(base, key);
        var value = desc.value;
        if (desc.get) {
            if (!invokeGetters) throw new Error("Immer drafts cannot have computed properties");
            value = desc.get.call(base);
        }
        if (desc.enumerable) clone[key] = value;
        else Object.defineProperty(clone, key, {
            value: value,
            writable: true,
            configurable: true
        });
    });
    return clone;
}
function freeze(obj, deep) {
    if (!isDraftable(obj) || isDraft(obj) || Object.isFrozen(obj)) return;
    var type = getArchtype(obj);
    if (type === Archtype.Set) obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    else if (type === Archtype.Map) obj.set = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) each(obj, function(_, value) {
        return freeze(value, true);
    });
}
function dontMutateFrozenCollections() {
    throw new Error("This object has been frozen and should not be mutated");
}
function createHiddenProperty(target, prop, value) {
    Object.defineProperty(target, prop, {
        value: value,
        enumerable: false,
        writable: true
    });
}
/* istanbul ignore next */ function die() {
    throw new Error("Illegal state, please file a bug");
}
/** Each scope represents a `produce` call. */ var ImmerScope = /** @class */ function() {
    function ImmerScope(parent, immer) {
        this.drafts = [];
        this.parent = parent;
        this.immer = immer; // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        this.canAutoFreeze = true;
    }
    ImmerScope.prototype.usePatches = function(patchListener) {
        if (patchListener) {
            this.patches = [];
            this.inversePatches = [];
            this.patchListener = patchListener;
        }
    };
    ImmerScope.prototype.revoke = function() {
        this.leave();
        this.drafts.forEach(revoke); // @ts-ignore
        this.drafts = null;
    };
    ImmerScope.prototype.leave = function() {
        if (this === ImmerScope.current) ImmerScope.current = this.parent;
    };
    ImmerScope.enter = function(immer) {
        var scope = new ImmerScope(ImmerScope.current, immer);
        ImmerScope.current = scope;
        return scope;
    };
    return ImmerScope;
}();
function revoke(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type === ProxyType.ProxyObject || state.type === ProxyType.ProxyArray) state.revoke();
    else state.revoked = true;
}
function processResult(immer, result, scope) {
    var baseDraft = scope.drafts[0];
    var isReplaced = result !== undefined && result !== baseDraft;
    immer.willFinalize(scope, result, isReplaced);
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified) {
            scope.revoke();
            throw new Error("An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft."); // prettier-ignore
        }
        if (isDraftable(result)) {
            // Finalize the result in case it contains (or is) a subset of the draft.
            result = finalize(immer, result, scope);
            if (!scope.parent) maybeFreeze(immer, result);
        }
        if (scope.patches) {
            scope.patches.push({
                op: "replace",
                path: [],
                value: result
            });
            scope.inversePatches.push({
                op: "replace",
                path: [],
                value: baseDraft[DRAFT_STATE].base
            });
        }
    } else // Finalize the base draft.
    result = finalize(immer, baseDraft, scope, []);
    scope.revoke();
    if (scope.patches) scope.patchListener(scope.patches, scope.inversePatches);
    return result !== NOTHING ? result : undefined;
}
function finalize(immer, draft, scope, path) {
    var state = draft[DRAFT_STATE];
    if (!state) {
        if (Object.isFrozen(draft)) return draft;
        return finalizeTree(immer, draft, scope);
    } // Never finalize drafts owned by another scope.
    if (state.scope !== scope) return draft;
    if (!state.modified) {
        maybeFreeze(immer, state.base, true);
        return state.base;
    }
    if (!state.finalized) {
        state.finalized = true;
        finalizeTree(immer, state.draft, scope, path); // We cannot really delete anything inside of a Set. We can only replace the whole Set.
        if (immer.onDelete && state.type !== ProxyType.Set) {
            // The `assigned` object is unreliable with ES5 drafts.
            if (immer.useProxies) {
                var assigned = state.assigned;
                each(assigned, function(prop, exists) {
                    if (!exists) immer.onDelete(state, prop);
                });
            } else {
                var base = state.base, copy_1 = state.copy;
                each(base, function(prop) {
                    if (!has(copy_1, prop)) immer.onDelete(state, prop);
                });
            }
        }
        if (immer.onCopy) immer.onCopy(state);
         // At this point, all descendants of `state.copy` have been finalized,
        // so we can be sure that `scope.canAutoFreeze` is accurate.
        if (immer.autoFreeze && scope.canAutoFreeze) freeze(state.copy, false);
        if (path && scope.patches) generatePatches(state, path, scope.patches, scope.inversePatches);
    }
    return state.copy;
}
function finalizeTree(immer, root, scope, rootPath) {
    var state = root[DRAFT_STATE];
    if (state) {
        if (state.type === ProxyType.ES5Object || state.type === ProxyType.ES5Array) // Create the final copy, with added keys and without deleted keys.
        state.copy = shallowCopy(state.draft, true);
        root = state.copy;
    }
    each(root, function(key, value) {
        return finalizeProperty(immer, scope, root, state, root, key, value, rootPath);
    });
    return root;
}
function finalizeProperty(immer, scope, root, rootState, parentValue, prop, childValue, rootPath) {
    if (childValue === parentValue) throw Error("Immer forbids circular references");
     // In the `finalizeTree` method, only the `root` object may be a draft.
    var isDraftProp = !!rootState && parentValue === root;
    var isSetMember = isSet(parentValue);
    if (isDraft(childValue)) {
        var path = rootPath && isDraftProp && !isSetMember && // Set objects are atomic since they have no keys.
        !has(rootState.assigned, prop) // Skip deep patches for assigned keys.
         ? rootPath.concat(prop) : undefined; // Drafts owned by `scope` are finalized here.
        childValue = finalize(immer, childValue, scope, path);
        set(parentValue, prop, childValue); // Drafts from another scope must prevent auto-freezing.
        if (isDraft(childValue)) scope.canAutoFreeze = false;
    } else if (isDraftProp && is(childValue, get(rootState.base, prop))) return;
    else if (isDraftable(childValue)) {
        each(childValue, function(key, grandChild) {
            return finalizeProperty(immer, scope, root, rootState, childValue, key, grandChild, rootPath);
        });
        if (!scope.parent) maybeFreeze(immer, childValue);
    }
    if (isDraftProp && immer.onAssign && !isSetMember) immer.onAssign(rootState, prop, childValue);
}
function maybeFreeze(immer, value, deep) {
    if (deep === void 0) deep = false;
    if (immer.autoFreeze && !isDraft(value)) freeze(value, deep);
}
/**
 * Returns a new draft of the `base` object.
 *
 * The second argument is the parent draft-state (used internally).
 */ function createProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type: isArray ? ProxyType.ProxyArray : ProxyType.ProxyObject,
        // Track which produce call this is associated with.
        scope: parent ? parent.scope : ImmerScope.current,
        // True for both shallow and deep changes.
        modified: false,
        // Used during finalization.
        finalized: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned: {},
        // The parent draft state.
        parent: parent,
        // The base state.
        base: base,
        // The base proxy.
        draft: null,
        // Any property proxies.
        drafts: {},
        // The base copy with any updated values.
        copy: null,
        // Called by the `produce` function.
        revoke: null,
        isManual: false
    }; // the traps must target something, a bit like the 'real' base.
    // but also, we need to be able to determine from the target what the relevant state is
    // (to avoid creating traps per instance to capture the state in closure,
    // and to avoid creating weird hidden properties as well)
    // So the trick is to use 'state' as the actual 'target'! (and make sure we intercept everything)
    // Note that in the case of an array, we put the state in an array to have better Reflect defaults ootb
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    } // TODO: optimization: might be faster, cheaper if we created a non-revocable proxy
    // and administrate revoking ourselves
    var _a = Proxy.revocable(target, traps), revoke = _a.revoke, proxy = _a.proxy;
    state.draft = proxy;
    state.revoke = revoke;
    return proxy;
}
/**
 * Object drafts
 */ var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var drafts = state.drafts; // Check for existing draft in unmodified state.
        if (!state.modified && has(drafts, prop)) return drafts[prop];
        var value = latest(state)[prop];
        if (state.finalized || !isDraftable(value)) return value;
         // Check for existing draft in modified state.
        if (state.modified) {
            // Assigned values are never drafted. This catches any drafts we created, too.
            if (value !== peek(state.base, prop)) return value;
             // Store drafts on the copy (when one exists).
            // @ts-ignore
            drafts = state.copy;
        }
        return drafts[prop] = state.scope.immer.createProxy(value, state);
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        if (!state.modified) {
            var baseValue = peek(state.base, prop); // Optimize based on value's truthiness. Truthy values are guaranteed to
            // never be undefined, so we can avoid the `in` operator. Lastly, truthy
            // values may be drafts, but falsy values are never drafts.
            var isUnchanged = value ? is(baseValue, value) || value === state.drafts[prop] : is(baseValue, value) && prop in state.base;
            if (isUnchanged) return true;
            prepareCopy(state);
            markChanged(state);
        }
        state.assigned[prop] = true; // @ts-ignore
        state.copy[prop] = value;
        return true;
    },
    deleteProperty: function(state, prop) {
        // The `undefined` check is a fast path for pre-existing keys.
        if (peek(state.base, prop) !== undefined || prop in state.base) {
            state.assigned[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else if (state.assigned[prop]) // if an originally not assigned property was deleted
        delete state.assigned[prop];
         // @ts-ignore
        if (state.copy) delete state.copy[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (desc) {
            desc.writable = true;
            desc.configurable = state.type !== ProxyType.ProxyArray || prop !== "length";
        }
        return desc;
    },
    defineProperty: function() {
        throw new Error("Object.defineProperty() cannot be used on an Immer draft"); // prettier-ignore
    },
    getPrototypeOf: function(state) {
        return Object.getPrototypeOf(state.base);
    },
    setPrototypeOf: function() {
        throw new Error("Object.setPrototypeOf() cannot be used on an Immer draft"); // prettier-ignore
    }
};
/**
 * Array drafts
 */ var arrayTraps = {};
each(objectTraps, function(key, fn) {
    // @ts-ignore
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    if (isNaN(parseInt(prop))) throw new Error("Immer only supports deleting array indices"); // prettier-ignore
    return objectTraps.deleteProperty.call(this, state[0], prop);
};
arrayTraps.set = function(state, prop, value) {
    if (prop !== "length" && isNaN(parseInt(prop))) throw new Error("Immer only supports setting array indices and the 'length' property"); // prettier-ignore
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
/**
 * Map drafts
 */ // Access a property without creating an Immer draft.
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var desc = Reflect.getOwnPropertyDescriptor(state ? latest(state) : draft, prop);
    return desc && desc.value;
}
function markChanged(state) {
    if (!state.modified) {
        state.modified = true;
        if (state.type === ProxyType.ProxyObject || state.type === ProxyType.ProxyArray) {
            var copy_1 = state.copy = shallowCopy(state.base);
            each(state.drafts, function(key, value) {
                // @ts-ignore
                copy_1[key] = value;
            });
            state.drafts = undefined;
        }
        if (state.parent) markChanged(state.parent);
    }
}
function prepareCopy(state) {
    if (!state.copy) state.copy = shallowCopy(state.base);
}
function willFinalizeES5(scope, result, isReplaced) {
    scope.drafts.forEach(function(draft) {
        draft[DRAFT_STATE].finalizing = true;
    });
    if (!isReplaced) {
        if (scope.patches) markChangesRecursively(scope.drafts[0]);
         // This is faster when we don't care about which attributes changed.
        markChangesSweep(scope.drafts);
    } else if (isDraft(result) && result[DRAFT_STATE].scope === scope) markChangesSweep(scope.drafts);
}
function createES5Proxy(base, parent) {
    var isArray = Array.isArray(base);
    var draft = clonePotentialDraft(base);
    each(draft, function(prop) {
        proxyProperty(draft, prop, isArray || isEnumerable(base, prop));
    });
    var state = {
        type: isArray ? ProxyType.ES5Array : ProxyType.ES5Object,
        scope: parent ? parent.scope : ImmerScope.current,
        modified: false,
        finalizing: false,
        finalized: false,
        assigned: {},
        parent: parent,
        base: base,
        draft: draft,
        copy: null,
        revoked: false,
        isManual: false
    };
    createHiddenProperty(draft, DRAFT_STATE, state);
    return draft;
} // Access a property without creating an Immer draft.
function peek$1(draft, prop) {
    var state = draft[DRAFT_STATE];
    if (state && !state.finalizing) {
        state.finalizing = true;
        var value = draft[prop];
        state.finalizing = false;
        return value;
    }
    return draft[prop];
}
function get$1(state, prop) {
    assertUnrevoked(state);
    var value = peek$1(latest(state), prop);
    if (state.finalizing) return value;
     // Create a draft if the value is unmodified.
    if (value === peek$1(state.base, prop) && isDraftable(value)) {
        prepareCopy$1(state); // @ts-ignore
        return state.copy[prop] = state.scope.immer.createProxy(value, state);
    }
    return value;
}
function set$1(state, prop, value) {
    assertUnrevoked(state);
    state.assigned[prop] = true;
    if (!state.modified) {
        if (is(value, peek$1(latest(state), prop))) return;
        markChangedES5(state);
        prepareCopy$1(state);
    } // @ts-ignore
    state.copy[prop] = value;
}
function markChangedES5(state) {
    if (!state.modified) {
        state.modified = true;
        if (state.parent) markChangedES5(state.parent);
    }
}
function prepareCopy$1(state) {
    if (!state.copy) state.copy = clonePotentialDraft(state.base);
}
function clonePotentialDraft(base) {
    var state = base && base[DRAFT_STATE];
    if (state) {
        state.finalizing = true;
        var draft = shallowCopy(state.draft, true);
        state.finalizing = false;
        return draft;
    }
    return shallowCopy(base);
} // property descriptors are recycled to make sure we don't create a get and set closure per property,
// but share them all instead
var descriptors = {};
function proxyProperty(draft, prop, enumerable) {
    var desc = descriptors[prop];
    if (desc) desc.enumerable = enumerable;
    else descriptors[prop] = desc = {
        configurable: true,
        enumerable: enumerable,
        get: function() {
            return get$1(this[DRAFT_STATE], prop);
        },
        set: function(value) {
            set$1(this[DRAFT_STATE], prop, value);
        }
    };
    Object.defineProperty(draft, prop, desc);
}
function assertUnrevoked(state) {
    if (state.revoked === true) throw new Error("Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + JSON.stringify(latest(state)));
} // This looks expensive, but only proxies are visited, and only objects without known changes are scanned.
function markChangesSweep(drafts) {
    // The natural order of drafts in the `scope` array is based on when they
    // were accessed. By processing drafts in reverse natural order, we have a
    // better chance of processing leaf nodes first. When a leaf node is known to
    // have changed, we can avoid any traversal of its ancestor nodes.
    for(var i = drafts.length - 1; i >= 0; i--){
        var state = drafts[i][DRAFT_STATE];
        if (!state.modified) switch(state.type){
            case ProxyType.ES5Array:
                if (hasArrayChanges(state)) markChangedES5(state);
                break;
            case ProxyType.ES5Object:
                if (hasObjectChanges(state)) markChangedES5(state);
                break;
        }
    }
}
function markChangesRecursively(object) {
    if (!object || typeof object !== "object") return;
    var state = object[DRAFT_STATE];
    if (!state) return;
    var base = state.base, draft = state.draft, assigned = state.assigned, type = state.type;
    if (type === ProxyType.ES5Object) {
        // Look for added keys.
        // TODO: looks quite duplicate to hasObjectChanges,
        // probably there is a faster way to detect changes, as sweep + recurse seems to do some
        // unnecessary work.
        // also: probably we can store the information we detect here, to speed up tree finalization!
        each(draft, function(key) {
            if (key === DRAFT_STATE) return;
             // The `undefined` check is a fast path for pre-existing keys.
            if (base[key] === undefined && !has(base, key)) {
                assigned[key] = true;
                markChangedES5(state);
            } else if (!assigned[key]) // Only untouched properties trigger recursion.
            markChangesRecursively(draft[key]);
        }); // Look for removed keys.
        each(base, function(key) {
            // The `undefined` check is a fast path for pre-existing keys.
            if (draft[key] === undefined && !has(draft, key)) {
                assigned[key] = false;
                markChangedES5(state);
            }
        });
    } else if (type === ProxyType.ES5Array) {
        if (hasArrayChanges(state)) {
            markChangedES5(state);
            assigned.length = true;
        }
        if (draft.length < base.length) for(var i = draft.length; i < base.length; i++)assigned[i] = false;
        else for(var i = base.length; i < draft.length; i++)assigned[i] = true;
         // Minimum count is enough, the other parts has been processed.
        var min = Math.min(draft.length, base.length);
        for(var i = 0; i < min; i++)// Only untouched indices trigger recursion.
        if (assigned[i] === undefined) markChangesRecursively(draft[i]);
    }
}
function hasObjectChanges(state) {
    var base = state.base, draft = state.draft; // Search for added keys and changed keys. Start at the back, because
    // non-numeric keys are ordered by time of definition on the object.
    var keys = Object.keys(draft);
    for(var i = keys.length - 1; i >= 0; i--){
        var key = keys[i];
        var baseValue = base[key]; // The `undefined` check is a fast path for pre-existing keys.
        if (baseValue === undefined && !has(base, key)) return true;
        else {
            var value = draft[key];
            var state_1 = value && value[DRAFT_STATE];
            if (state_1 ? state_1.base !== baseValue : !is(value, baseValue)) return true;
        }
    } // At this point, no keys were added or changed.
    // Compare key count to determine if keys were deleted.
    return keys.length !== Object.keys(base).length;
}
function hasArrayChanges(state) {
    var draft = state.draft;
    if (draft.length !== state.base.length) return true;
     // See #116
    // If we first shorten the length, our array interceptors will be removed.
    // If after that new items are added, result in the same original length,
    // those last items will have no intercepting property.
    // So if there is no own descriptor on the last position, we know that items were removed and added
    // N.B.: splice, unshift, etc only shift values around, but not prop descriptors, so we only have to check
    // the last one
    var descriptor = Object.getOwnPropertyDescriptor(draft, draft.length - 1); // descriptor can be null, but only for newly created sparse arrays, eg. new Array(10)
    if (descriptor && !descriptor.get) return true;
     // For all other cases, we don't have to compare, as they would have been picked up by the index setters
    return false;
}
var DraftMap = function(_super) {
    if (!_super) /* istanbul ignore next */ throw new Error("Map is not polyfilled");
    __extends(DraftMap, _super); // Create class manually, cause #502
    function DraftMap(target, parent) {
        this[DRAFT_STATE] = {
            type: ProxyType.Map,
            parent: parent,
            scope: parent ? parent.scope : ImmerScope.current,
            modified: false,
            finalized: false,
            copy: undefined,
            assigned: undefined,
            base: target,
            draft: this,
            isManual: false,
            revoked: false
        };
        return this;
    }
    var p = DraftMap.prototype; // TODO: smaller build size if we create a util for Object.defineProperty
    Object.defineProperty(p, "size", {
        get: function() {
            return latest(this[DRAFT_STATE]).size;
        },
        enumerable: true,
        configurable: true
    });
    p.has = function(key) {
        return latest(this[DRAFT_STATE]).has(key);
    };
    p.set = function(key, value) {
        var state = this[DRAFT_STATE];
        assertUnrevoked(state);
        if (latest(state).get(key) !== value) {
            prepareCopy$2(state);
            state.scope.immer.markChanged(state);
            state.assigned.set(key, true);
            state.copy.set(key, value);
            state.assigned.set(key, true);
        }
        return this;
    };
    p.delete = function(key) {
        if (!this.has(key)) return false;
        var state = this[DRAFT_STATE];
        assertUnrevoked(state);
        prepareCopy$2(state);
        state.scope.immer.markChanged(state);
        state.assigned.set(key, false);
        state.copy.delete(key);
        return true;
    };
    p.clear = function() {
        var state = this[DRAFT_STATE];
        assertUnrevoked(state);
        prepareCopy$2(state);
        state.scope.immer.markChanged(state);
        state.assigned = new Map();
        return state.copy.clear();
    };
    p.forEach = function(cb, thisArg) {
        var _this = this;
        var state = this[DRAFT_STATE];
        latest(state).forEach(function(_value, key, _map) {
            cb.call(thisArg, _this.get(key), key, _this);
        });
    };
    p.get = function(key) {
        var state = this[DRAFT_STATE];
        assertUnrevoked(state);
        var value = latest(state).get(key);
        if (state.finalized || !isDraftable(value)) return value;
        if (value !== state.base.get(key)) return value; // either already drafted or reassigned
         // despite what it looks, this creates a draft only once, see above condition
        var draft = state.scope.immer.createProxy(value, state);
        prepareCopy$2(state);
        state.copy.set(key, draft);
        return draft;
    };
    p.keys = function() {
        return latest(this[DRAFT_STATE]).keys();
    };
    p.values = function() {
        var _a;
        var _this = this;
        var iterator = this.keys();
        return _a = {}, _a[iteratorSymbol] = function() {
            return _this.values();
        }, _a.next = function() {
            var r = iterator.next();
            /* istanbul ignore next */ if (r.done) return r;
            var value = _this.get(r.value);
            return {
                done: false,
                value: value
            };
        }, _a;
    };
    p.entries = function() {
        var _a;
        var _this = this;
        var iterator = this.keys();
        return _a = {}, _a[iteratorSymbol] = function() {
            return _this.entries();
        }, _a.next = function() {
            var r = iterator.next();
            /* istanbul ignore next */ if (r.done) return r;
            var value = _this.get(r.value);
            return {
                done: false,
                value: [
                    r.value,
                    value
                ]
            };
        }, _a;
    };
    p[iteratorSymbol] = function() {
        return this.entries();
    };
    return DraftMap;
}(Map);
function proxyMap(target, parent) {
    // @ts-ignore
    return new DraftMap(target, parent);
}
function prepareCopy$2(state) {
    if (!state.copy) {
        state.assigned = new Map();
        state.copy = new Map(state.base);
    }
}
var DraftSet = function(_super) {
    if (!_super) /* istanbul ignore next */ throw new Error("Set is not polyfilled");
    __extends(DraftSet, _super); // Create class manually, cause #502
    function DraftSet(target, parent) {
        this[DRAFT_STATE] = {
            type: ProxyType.Set,
            parent: parent,
            scope: parent ? parent.scope : ImmerScope.current,
            modified: false,
            finalized: false,
            copy: undefined,
            base: target,
            draft: this,
            drafts: new Map(),
            revoked: false,
            isManual: false
        };
        return this;
    }
    var p = DraftSet.prototype;
    Object.defineProperty(p, "size", {
        get: function() {
            return latest(this[DRAFT_STATE]).size;
        },
        enumerable: true,
        configurable: true
    });
    p.has = function(value) {
        var state = this[DRAFT_STATE];
        assertUnrevoked(state); // bit of trickery here, to be able to recognize both the value, and the draft of its value
        if (!state.copy) return state.base.has(value);
        if (state.copy.has(value)) return true;
        if (state.drafts.has(value) && state.copy.has(state.drafts.get(value))) return true;
        return false;
    };
    p.add = function(value) {
        var state = this[DRAFT_STATE];
        assertUnrevoked(state);
        if (state.copy) state.copy.add(value);
        else if (!state.base.has(value)) {
            prepareCopy$3(state);
            state.scope.immer.markChanged(state);
            state.copy.add(value);
        }
        return this;
    };
    p.delete = function(value) {
        if (!this.has(value)) return false;
        var state = this[DRAFT_STATE];
        assertUnrevoked(state);
        prepareCopy$3(state);
        state.scope.immer.markChanged(state);
        return state.copy.delete(value) || (state.drafts.has(value) ? state.copy.delete(state.drafts.get(value)) : /* istanbul ignore next */ false);
    };
    p.clear = function() {
        var state = this[DRAFT_STATE];
        assertUnrevoked(state);
        prepareCopy$3(state);
        state.scope.immer.markChanged(state);
        return state.copy.clear();
    };
    p.values = function() {
        var state = this[DRAFT_STATE];
        assertUnrevoked(state);
        prepareCopy$3(state);
        return state.copy.values();
    };
    p.entries = function entries() {
        var state = this[DRAFT_STATE];
        assertUnrevoked(state);
        prepareCopy$3(state);
        return state.copy.entries();
    };
    p.keys = function() {
        return this.values();
    };
    p[iteratorSymbol] = function() {
        return this.values();
    };
    p.forEach = function forEach(cb, thisArg) {
        var iterator = this.values();
        var result = iterator.next();
        while(!result.done){
            cb.call(thisArg, result.value, result.value, this);
            result = iterator.next();
        }
    };
    return DraftSet;
}(Set);
function proxySet(target, parent) {
    // @ts-ignore
    return new DraftSet(target, parent);
}
function prepareCopy$3(state) {
    if (!state.copy) {
        // create drafts for all entries to preserve insertion order
        state.copy = new Set();
        state.base.forEach(function(value) {
            if (isDraftable(value)) {
                var draft = state.scope.immer.createProxy(value, state);
                state.drafts.set(value, draft);
                state.copy.add(draft);
            } else state.copy.add(value);
        });
    }
}
function generatePatches(state, basePath, patches, inversePatches) {
    switch(state.type){
        case ProxyType.ProxyObject:
        case ProxyType.ES5Object:
        case ProxyType.Map:
            return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
        case ProxyType.ES5Array:
        case ProxyType.ProxyArray:
            return generateArrayPatches(state, basePath, patches, inversePatches);
        case ProxyType.Set:
            return generateSetPatches(state, basePath, patches, inversePatches);
    }
}
function generateArrayPatches(state, basePath, patches, inversePatches) {
    var _a, _b;
    var base = state.base, assigned = state.assigned, copy = state.copy;
    /* istanbul ignore next */ if (!copy) die();
     // Reduce complexity by ensuring `base` is never longer.
    if (copy.length < base.length) {
        _a = [
            copy,
            base
        ], base = _a[0], copy = _a[1];
        _b = [
            inversePatches,
            patches
        ], patches = _b[0], inversePatches = _b[1];
    }
    var delta = copy.length - base.length; // Find the first replaced index.
    var start = 0;
    while(base[start] === copy[start] && start < base.length)++start;
     // Find the last replaced index. Search from the end to optimize splice patches.
    var end = base.length;
    while(end > start && base[end - 1] === copy[end + delta - 1])--end;
     // Process replaced indices.
    for(var i = start; i < end; ++i)if (assigned[i] && copy[i] !== base[i]) {
        var path = basePath.concat([
            i
        ]);
        patches.push({
            op: "replace",
            path: path,
            value: copy[i]
        });
        inversePatches.push({
            op: "replace",
            path: path,
            value: base[i]
        });
    }
    var replaceCount = patches.length; // Process added indices.
    for(var i = end + delta - 1; i >= end; --i){
        var path = basePath.concat([
            i
        ]);
        patches[replaceCount + i - end] = {
            op: "add",
            path: path,
            value: copy[i]
        };
        inversePatches.push({
            op: "remove",
            path: path
        });
    }
} // This is used for both Map objects and normal objects.
function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
    var base = state.base, copy = state.copy;
    each(state.assigned, function(key, assignedValue) {
        var origValue = get(base, key);
        var value = get(copy, key);
        var op = !assignedValue ? "remove" : has(base, key) ? "replace" : "add";
        if (origValue === value && op === "replace") return;
        var path = basePath.concat(key);
        patches.push(op === "remove" ? {
            op: op,
            path: path
        } : {
            op: op,
            path: path,
            value: value
        });
        inversePatches.push(op === "add" ? {
            op: "remove",
            path: path
        } : op === "remove" ? {
            op: "add",
            path: path,
            value: origValue
        } : {
            op: "replace",
            path: path,
            value: origValue
        });
    });
}
function generateSetPatches(state, basePath, patches, inversePatches) {
    var base = state.base, copy = state.copy;
    var i = 0;
    base.forEach(function(value) {
        if (!copy.has(value)) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: "remove",
                path: path,
                value: value
            });
            inversePatches.unshift({
                op: "add",
                path: path,
                value: value
            });
        }
        i++;
    });
    i = 0;
    copy.forEach(function(value) {
        if (!base.has(value)) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: "add",
                path: path,
                value: value
            });
            inversePatches.unshift({
                op: "remove",
                path: path,
                value: value
            });
        }
        i++;
    });
}
function applyPatches(draft, patches) {
    patches.forEach(function(patch) {
        var path = patch.path, op = patch.op;
        /* istanbul ignore next */ if (!path.length) die();
        var base = draft;
        for(var i = 0; i < path.length - 1; i++){
            base = get(base, path[i]);
            if (!base || typeof base !== "object") throw new Error("Cannot apply patch, path doesn't resolve: " + path.join("/"));
             // prettier-ignore
        }
        var type = getArchtype(base);
        var value = deepClonePatchValue(patch.value); // used to clone patch to ensure original patch is not modified, see #411
        var key = path[path.length - 1];
        switch(op){
            case "replace":
                switch(type){
                    case Archtype.Map:
                        return base.set(key, value);
                    /* istanbul ignore next */ case Archtype.Set:
                        throw new Error('Sets cannot have "replace" patches.');
                    default:
                        // if value is an object, then it's assigned by reference
                        // in the following add or remove ops, the value field inside the patch will also be modifyed
                        // so we use value from the cloned patch
                        // @ts-ignore
                        return base[key] = value;
                }
            case "add":
                switch(type){
                    case Archtype.Array:
                        return base.splice(key, 0, value);
                    case Archtype.Map:
                        return base.set(key, value);
                    case Archtype.Set:
                        return base.add(value);
                    default:
                        return base[key] = value;
                }
            case "remove":
                switch(type){
                    case Archtype.Array:
                        return base.splice(key, 1);
                    case Archtype.Map:
                        return base.delete(key);
                    case Archtype.Set:
                        return base.delete(patch.value);
                    default:
                        return delete base[key];
                }
            default:
                throw new Error("Unsupported patch operation: " + op);
        }
    });
    return draft;
}
function deepClonePatchValue(obj) {
    if (!obj || typeof obj !== "object") return obj;
    if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
    if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            deepClonePatchValue(v)
        ];
    }));
    if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
    var cloned = Object.create(Object.getPrototypeOf(obj));
    for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
    return cloned;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
/* istanbul ignore next */ function verifyMinified() {}
var configDefaults = {
    useProxies: typeof Proxy !== "undefined" && typeof Proxy.revocable !== "undefined" && typeof Reflect !== "undefined",
    autoFreeze: /* istanbul ignore next */ verifyMinified.name === "verifyMinified",
    onAssign: null,
    onDelete: null,
    onCopy: null
};
var Immer = /** @class */ function() {
    function Immer(config) {
        var _this = this;
        this.useProxies = false;
        this.autoFreeze = false;
        each(configDefaults, function(key, value) {
            var _a, _b; // @ts-ignore
            _this[key] = (_b = (_a = config) === null || _a === void 0 ? void 0 : _a[key], _b !== null && _b !== void 0 ? _b : value);
        });
        this.setUseProxies(this.useProxies);
        this.produce = this.produce.bind(this);
        this.produceWithPatches = this.produceWithPatches.bind(this);
    }
    /**
   * The `produce` function takes a value and a "recipe function" (whose
   * return value often depends on the base state). The recipe function is
   * free to mutate its first argument however it wants. All mutations are
   * only ever applied to a __copy__ of the base state.
   *
   * Pass only a function to create a "curried producer" which relieves you
   * from passing the recipe function every time.
   *
   * Only plain objects and arrays are made mutable. All other objects are
   * considered uncopyable.
   *
   * Note: This function is __bound__ to its `Immer` instance.
   *
   * @param {any} base - the initial state
   * @param {Function} producer - function that receives a proxy of the base state as first argument and which can be freely modified
   * @param {Function} patchListener - optional function that will be called with all the patches produced here
   * @returns {any} a new state, or the initial state if nothing was modified
   */ Immer.prototype.produce = function(base, recipe, patchListener) {
        var _this = this; // curried invocation
        if (typeof base === "function" && typeof recipe !== "function") {
            var defaultBase_1 = recipe;
            recipe = base;
            var self_1 = this;
            return function curriedProduce(base) {
                var arguments$1 = arguments;
                var _this = this;
                if (base === void 0) base = defaultBase_1;
                var args = [];
                for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments$1[_i];
                return self_1.produce(base, function(draft) {
                    return recipe.call.apply(recipe, __spreadArrays([
                        _this,
                        draft
                    ], args));
                }); // prettier-ignore
            };
        } // prettier-ignore
        if (typeof recipe !== "function") throw new Error("The first or second argument to `produce` must be a function");
        if (patchListener !== undefined && typeof patchListener !== "function") throw new Error("The third argument to `produce` must be a function or undefined");
        var result; // Only plain objects, arrays, and "immerable classes" are drafted.
        if (isDraftable(base)) {
            var scope_1 = ImmerScope.enter(this);
            var proxy = this.createProxy(base, undefined);
            var hasError = true;
            try {
                result = recipe(proxy);
                hasError = false;
            } finally{
                // finally instead of catch + rethrow better preserves original stack
                if (hasError) scope_1.revoke();
                else scope_1.leave();
            }
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then(function(result) {
                scope_1.usePatches(patchListener);
                return processResult(_this, result, scope_1);
            }, function(error) {
                scope_1.revoke();
                throw error;
            });
            scope_1.usePatches(patchListener);
            return processResult(this, result, scope_1);
        } else {
            result = recipe(base);
            if (result === NOTHING) return undefined;
            if (result === undefined) result = base;
            maybeFreeze(this, result, true);
            return result;
        }
    };
    Immer.prototype.produceWithPatches = function(arg1, arg2, arg3) {
        var _this = this;
        if (typeof arg1 === "function") return function(state) {
            var arguments$1 = arguments;
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments$1[_i];
            return _this.produceWithPatches(state, function(draft) {
                return arg1.apply(void 0, __spreadArrays([
                    draft
                ], args));
            });
        };
         // non-curried form
        /* istanbul ignore next */ if (arg3) die();
        var patches, inversePatches;
        var nextState = this.produce(arg1, arg2, function(p, ip) {
            patches = p;
            inversePatches = ip;
        });
        return [
            nextState,
            patches,
            inversePatches
        ];
    };
    Immer.prototype.createDraft = function(base) {
        if (!isDraftable(base)) throw new Error("First argument to `createDraft` must be a plain object, an array, or an immerable object"); // prettier-ignore
        var scope = ImmerScope.enter(this);
        var proxy = this.createProxy(base, undefined);
        proxy[DRAFT_STATE].isManual = true;
        scope.leave();
        return proxy;
    };
    Immer.prototype.finishDraft = function(draft, patchListener) {
        var state = draft && draft[DRAFT_STATE];
        if (!state || !state.isManual) throw new Error("First argument to `finishDraft` must be a draft returned by `createDraft`"); // prettier-ignore
        if (state.finalized) throw new Error("The given draft is already finalized"); // prettier-ignore
        var scope = state.scope;
        scope.usePatches(patchListener);
        return processResult(this, undefined, scope);
    };
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is disabled in production.
   */ Immer.prototype.setAutoFreeze = function(value) {
        this.autoFreeze = value;
    };
    /**
   * Pass true to use the ES2015 `Proxy` class when creating drafts, which is
   * always faster than using ES5 proxies.
   *
   * By default, feature detection is used, so calling this is rarely necessary.
   */ Immer.prototype.setUseProxies = function(value) {
        this.useProxies = value;
    };
    Immer.prototype.applyPatches = function(base, patches) {
        // If a patch replaces the entire state, take that replacement as base
        // before applying patches
        var i;
        for(i = patches.length - 1; i >= 0; i--){
            var patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (isDraft(base)) // N.B: never hits if some patch a replacement, patches are never drafts
        return applyPatches(base, patches);
         // Otherwise, produce a copy of the base state.
        return this.produce(base, function(draft) {
            return applyPatches(draft, patches.slice(i + 1));
        });
    };
    Immer.prototype.createProxy = function(value, parent) {
        // precondition: createProxy should be guarded by isDraftable, so we know we can safely draft
        var draft = isMap(value) ? proxyMap(value, parent) : isSet(value) ? proxySet(value, parent) : this.useProxies ? createProxy(value, parent) : createES5Proxy(value, parent);
        var scope = parent ? parent.scope : ImmerScope.current;
        scope.drafts.push(draft);
        return draft;
    };
    Immer.prototype.willFinalize = function(scope, thing, isReplaced) {
        if (!this.useProxies) willFinalizeES5(scope, thing, isReplaced);
    };
    Immer.prototype.markChanged = function(state) {
        if (this.useProxies) markChanged(state);
        else markChangedES5(state);
    };
    return Immer;
}();
var immer = new Immer();
/**
 * The `produce` function takes a value and a "recipe function" (whose
 * return value often depends on the base state). The recipe function is
 * free to mutate its first argument however it wants. All mutations are
 * only ever applied to a __copy__ of the base state.
 *
 * Pass only a function to create a "curried producer" which relieves you
 * from passing the recipe function every time.
 *
 * Only plain objects and arrays are made mutable. All other objects are
 * considered uncopyable.
 *
 * Note: This function is __bound__ to its `Immer` instance.
 *
 * @param {any} base - the initial state
 * @param {Function} producer - function that receives a proxy of the base state as first argument and which can be freely modified
 * @param {Function} patchListener - optional function that will be called with all the patches produced here
 * @returns {any} a new state, or the initial state if nothing was modified
 */ var produce = immer.produce;
/**
 * Like `produce`, but `produceWithPatches` always returns a tuple
 * [nextState, patches, inversePatches] (instead of just the next state)
 */ var produceWithPatches = immer.produceWithPatches.bind(immer);
/**
 * Pass true to automatically freeze all copies created by Immer.
 *
 * By default, auto-freezing is disabled in production.
 */ var setAutoFreeze = immer.setAutoFreeze.bind(immer);
/**
 * Pass true to use the ES2015 `Proxy` class when creating drafts, which is
 * always faster than using ES5 proxies.
 *
 * By default, feature detection is used, so calling this is rarely necessary.
 */ var setUseProxies = immer.setUseProxies.bind(immer);
/**
 * Apply an array of Immer patches to the first argument.
 *
 * This function is a producer, which means copy-on-write is in effect.
 */ var applyPatches$1 = immer.applyPatches.bind(immer);
/**
 * Create an Immer draft from the given base state, which may be a draft itself.
 * The draft can be modified until you finalize it with the `finishDraft` function.
 */ var createDraft = immer.createDraft.bind(immer);
/**
 * Finalize an Immer draft from a `createDraft` call, returning the base state
 * (if no changes were made) or a modified copy. The draft must *not* be
 * mutated afterwards.
 *
 * Pass a function as the 2nd argument to generate Immer patches based on the
 * changes that were made.
 */ var finishDraft = immer.finishDraft.bind(immer);
/**
 * This function is actually a no-op, but can be used to cast an immutable type
 * to an draft type and make TypeScript happy
 *
 * @param value
 */ function castDraft(value) {
    return value;
}
/**
 * This function is actually a no-op, but can be used to cast a mutable type
 * to an immutable type and make TypeScript happy
 * @param value
 */ function castImmutable(value) {
    return value;
}
var $26e04f88d18e3c01$export$2e2bcd8739ae039 = produce;

});

parcelRegister("fjfo2", function(module, exports) {
// randomColor by David Merfield under the CC0 license
// https://github.com/davidmerfield/randomColor/
(function(root, factory) {
    var randomColor = factory();
    // Support NodeJS & Component, which allow module.exports to be a function
    if (module && module.exports) exports = module.exports = randomColor;
    // Support CommonJS 1.1.1 spec
    exports.randomColor = randomColor;
})(this, function() {
    // Seed to get repeatable colors
    var seed = null;
    // Shared color dictionary
    var colorDictionary = {};
    // Populate the color dictionary
    loadColorBounds();
    // check if a range is taken
    var colorRanges = [];
    var randomColor = function(options) {
        options = options || {};
        // Check if there is a seed and ensure it's an
        // integer. Otherwise, reset the seed value.
        if (options.seed !== undefined && options.seed !== null && options.seed === parseInt(options.seed, 10)) seed = options.seed;
        else if (typeof options.seed === 'string') seed = stringToInteger(options.seed);
        else if (options.seed !== undefined && options.seed !== null) throw new TypeError('The seed value must be an integer or string');
        else seed = null;
        var H, S, B;
        // Check if we need to generate multiple colors
        if (options.count !== null && options.count !== undefined) {
            var totalColors = options.count, colors = [];
            // Value false at index i means the range i is not taken yet.
            for(var i = 0; i < options.count; i++)colorRanges.push(false);
            options.count = null;
            while(totalColors > colors.length){
                var color = randomColor(options);
                if (seed !== null) options.seed = seed;
                colors.push(color);
            }
            options.count = totalColors;
            return colors;
        }
        // First we pick a hue (H)
        H = pickHue(options);
        // Then use H to determine saturation (S)
        S = pickSaturation(H, options);
        // Then use S and H to determine brightness (B).
        B = pickBrightness(H, S, options);
        // Then we return the HSB color in the desired format
        return setFormat([
            H,
            S,
            B
        ], options);
    };
    function pickHue(options) {
        if (colorRanges.length > 0) {
            var hueRange = getRealHueRange(options.hue);
            var hue = randomWithin(hueRange);
            //Each of colorRanges.length ranges has a length equal approximatelly one step
            var step = (hueRange[1] - hueRange[0]) / colorRanges.length;
            var j = parseInt((hue - hueRange[0]) / step);
            //Check if the range j is taken
            if (colorRanges[j] === true) j = (j + 2) % colorRanges.length;
            else colorRanges[j] = true;
            var min = (hueRange[0] + j * step) % 359, max = (hueRange[0] + (j + 1) * step) % 359;
            hueRange = [
                min,
                max
            ];
            hue = randomWithin(hueRange);
            if (hue < 0) hue = 360 + hue;
            return hue;
        } else {
            var hueRange = getHueRange(options.hue);
            hue = randomWithin(hueRange);
            // Instead of storing red as two seperate ranges,
            // we group them, using negative numbers
            if (hue < 0) hue = 360 + hue;
            return hue;
        }
    }
    function pickSaturation(hue, options) {
        if (options.hue === 'monochrome') return 0;
        if (options.luminosity === 'random') return randomWithin([
            0,
            100
        ]);
        var saturationRange = getSaturationRange(hue);
        var sMin = saturationRange[0], sMax = saturationRange[1];
        switch(options.luminosity){
            case 'bright':
                sMin = 55;
                break;
            case 'dark':
                sMin = sMax - 10;
                break;
            case 'light':
                sMax = 55;
                break;
        }
        return randomWithin([
            sMin,
            sMax
        ]);
    }
    function pickBrightness(H, S, options) {
        var bMin = getMinimumBrightness(H, S), bMax = 100;
        switch(options.luminosity){
            case 'dark':
                bMax = bMin + 20;
                break;
            case 'light':
                bMin = (bMax + bMin) / 2;
                break;
            case 'random':
                bMin = 0;
                bMax = 100;
                break;
        }
        return randomWithin([
            bMin,
            bMax
        ]);
    }
    function setFormat(hsv, options) {
        switch(options.format){
            case 'hsvArray':
                return hsv;
            case 'hslArray':
                return HSVtoHSL(hsv);
            case 'hsl':
                var hsl = HSVtoHSL(hsv);
                return 'hsl(' + hsl[0] + ', ' + hsl[1] + '%, ' + hsl[2] + '%)';
            case 'hsla':
                var hslColor = HSVtoHSL(hsv);
                var alpha = options.alpha || Math.random();
                return 'hsla(' + hslColor[0] + ', ' + hslColor[1] + '%, ' + hslColor[2] + '%, ' + alpha + ')';
            case 'rgbArray':
                return HSVtoRGB(hsv);
            case 'rgb':
                var rgb = HSVtoRGB(hsv);
                return 'rgb(' + rgb.join(', ') + ')';
            case 'rgba':
                var rgbColor = HSVtoRGB(hsv);
                var alpha = options.alpha || Math.random();
                return 'rgba(' + rgbColor.join(', ') + ', ' + alpha + ')';
            default:
                return HSVtoHex(hsv);
        }
    }
    function getMinimumBrightness(H, S) {
        var lowerBounds = getColorInfo(H).lowerBounds;
        for(var i = 0; i < lowerBounds.length - 1; i++){
            var s1 = lowerBounds[i][0], v1 = lowerBounds[i][1];
            var s2 = lowerBounds[i + 1][0], v2 = lowerBounds[i + 1][1];
            if (S >= s1 && S <= s2) {
                var m = (v2 - v1) / (s2 - s1), b = v1 - m * s1;
                return m * S + b;
            }
        }
        return 0;
    }
    function getHueRange(colorInput) {
        if (typeof parseInt(colorInput) === 'number') {
            var number = parseInt(colorInput);
            if (number < 360 && number > 0) return [
                number,
                number
            ];
        }
        if (typeof colorInput === 'string') {
            if (colorDictionary[colorInput]) {
                var color = colorDictionary[colorInput];
                if (color.hueRange) return color.hueRange;
            } else if (colorInput.match(/^#?([0-9A-F]{3}|[0-9A-F]{6})$/i)) {
                var hue = HexToHSB(colorInput)[0];
                return [
                    hue,
                    hue
                ];
            }
        }
        return [
            0,
            360
        ];
    }
    function getSaturationRange(hue) {
        return getColorInfo(hue).saturationRange;
    }
    function getColorInfo(hue) {
        // Maps red colors to make picking hue easier
        if (hue >= 334 && hue <= 360) hue -= 360;
        for(var colorName in colorDictionary){
            var color = colorDictionary[colorName];
            if (color.hueRange && hue >= color.hueRange[0] && hue <= color.hueRange[1]) return colorDictionary[colorName];
        }
        return 'Color not found';
    }
    function randomWithin(range) {
        if (seed === null) {
            //generate random evenly destinct number from : https://martin.ankerl.com/2009/12/09/how-to-create-random-colors-programmatically/
            var golden_ratio = 0.618033988749895;
            var r = Math.random();
            r += golden_ratio;
            r %= 1;
            return Math.floor(range[0] + r * (range[1] + 1 - range[0]));
        } else {
            //Seeded random algorithm from http://indiegamr.com/generate-repeatable-random-numbers-in-js/
            var max = range[1] || 1;
            var min = range[0] || 0;
            seed = (seed * 9301 + 49297) % 233280;
            var rnd = seed / 233280.0;
            return Math.floor(min + rnd * (max - min));
        }
    }
    function HSVtoHex(hsv) {
        var rgb = HSVtoRGB(hsv);
        function componentToHex(c) {
            var hex = c.toString(16);
            return hex.length == 1 ? '0' + hex : hex;
        }
        var hex = '#' + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);
        return hex;
    }
    function defineColor(name, hueRange, lowerBounds) {
        var sMin = lowerBounds[0][0], sMax = lowerBounds[lowerBounds.length - 1][0], bMin = lowerBounds[lowerBounds.length - 1][1], bMax = lowerBounds[0][1];
        colorDictionary[name] = {
            hueRange: hueRange,
            lowerBounds: lowerBounds,
            saturationRange: [
                sMin,
                sMax
            ],
            brightnessRange: [
                bMin,
                bMax
            ]
        };
    }
    function loadColorBounds() {
        defineColor('monochrome', null, [
            [
                0,
                0
            ],
            [
                100,
                0
            ]
        ]);
        defineColor('red', [
            -26,
            18
        ], [
            [
                20,
                100
            ],
            [
                30,
                92
            ],
            [
                40,
                89
            ],
            [
                50,
                85
            ],
            [
                60,
                78
            ],
            [
                70,
                70
            ],
            [
                80,
                60
            ],
            [
                90,
                55
            ],
            [
                100,
                50
            ]
        ]);
        defineColor('orange', [
            18,
            46
        ], [
            [
                20,
                100
            ],
            [
                30,
                93
            ],
            [
                40,
                88
            ],
            [
                50,
                86
            ],
            [
                60,
                85
            ],
            [
                70,
                70
            ],
            [
                100,
                70
            ]
        ]);
        defineColor('yellow', [
            46,
            62
        ], [
            [
                25,
                100
            ],
            [
                40,
                94
            ],
            [
                50,
                89
            ],
            [
                60,
                86
            ],
            [
                70,
                84
            ],
            [
                80,
                82
            ],
            [
                90,
                80
            ],
            [
                100,
                75
            ]
        ]);
        defineColor('green', [
            62,
            178
        ], [
            [
                30,
                100
            ],
            [
                40,
                90
            ],
            [
                50,
                85
            ],
            [
                60,
                81
            ],
            [
                70,
                74
            ],
            [
                80,
                64
            ],
            [
                90,
                50
            ],
            [
                100,
                40
            ]
        ]);
        defineColor('blue', [
            178,
            257
        ], [
            [
                20,
                100
            ],
            [
                30,
                86
            ],
            [
                40,
                80
            ],
            [
                50,
                74
            ],
            [
                60,
                60
            ],
            [
                70,
                52
            ],
            [
                80,
                44
            ],
            [
                90,
                39
            ],
            [
                100,
                35
            ]
        ]);
        defineColor('purple', [
            257,
            282
        ], [
            [
                20,
                100
            ],
            [
                30,
                87
            ],
            [
                40,
                79
            ],
            [
                50,
                70
            ],
            [
                60,
                65
            ],
            [
                70,
                59
            ],
            [
                80,
                52
            ],
            [
                90,
                45
            ],
            [
                100,
                42
            ]
        ]);
        defineColor('pink', [
            282,
            334
        ], [
            [
                20,
                100
            ],
            [
                30,
                90
            ],
            [
                40,
                86
            ],
            [
                60,
                84
            ],
            [
                80,
                80
            ],
            [
                90,
                75
            ],
            [
                100,
                73
            ]
        ]);
    }
    function HSVtoRGB(hsv) {
        // this doesn't work for the values of 0 and 360
        // here's the hacky fix
        var h = hsv[0];
        if (h === 0) h = 1;
        if (h === 360) h = 359;
        // Rebase the h,s,v values
        h = h / 360;
        var s = hsv[1] / 100, v = hsv[2] / 100;
        var h_i = Math.floor(h * 6), f = h * 6 - h_i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), r = 256, g = 256, b = 256;
        switch(h_i){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
        }
        var result = [
            Math.floor(r * 255),
            Math.floor(g * 255),
            Math.floor(b * 255)
        ];
        return result;
    }
    function HexToHSB(hex) {
        hex = hex.replace(/^#/, '');
        hex = hex.length === 3 ? hex.replace(/(.)/g, '$1$1') : hex;
        var red = parseInt(hex.substr(0, 2), 16) / 255, green = parseInt(hex.substr(2, 2), 16) / 255, blue = parseInt(hex.substr(4, 2), 16) / 255;
        var cMax = Math.max(red, green, blue), delta = cMax - Math.min(red, green, blue), saturation = cMax ? delta / cMax : 0;
        switch(cMax){
            case red:
                return [
                    60 * ((green - blue) / delta % 6) || 0,
                    saturation,
                    cMax
                ];
            case green:
                return [
                    60 * ((blue - red) / delta + 2) || 0,
                    saturation,
                    cMax
                ];
            case blue:
                return [
                    60 * ((red - green) / delta + 4) || 0,
                    saturation,
                    cMax
                ];
        }
    }
    function HSVtoHSL(hsv) {
        var h = hsv[0], s = hsv[1] / 100, v = hsv[2] / 100, k = (2 - s) * v;
        return [
            h,
            Math.round(s * v / (k < 1 ? k : 2 - k) * 10000) / 100,
            k / 2 * 100
        ];
    }
    function stringToInteger(string) {
        var total = 0;
        for(var i = 0; i !== string.length; i++){
            if (total >= Number.MAX_SAFE_INTEGER) break;
            total += string.charCodeAt(i);
        }
        return total;
    }
    // get The range of given hue when options.count!=0
    function getRealHueRange(colorHue) {
        if (!isNaN(colorHue)) {
            var number = parseInt(colorHue);
            if (number < 360 && number > 0) return getColorInfo(colorHue).hueRange;
        } else if (typeof colorHue === 'string') {
            if (colorDictionary[colorHue]) {
                var color = colorDictionary[colorHue];
                if (color.hueRange) return color.hueRange;
            } else if (colorHue.match(/^#?([0-9A-F]{3}|[0-9A-F]{6})$/i)) {
                var hue = HexToHSB(colorHue)[0];
                return getColorInfo(hue).hueRange;
            }
        }
        return [
            0,
            360
        ];
    }
    return randomColor;
});

});

// client-side js
// run by the browser each time your view template is loaded
var $589baecd24708921$exports = {};













































$589baecd24708921$exports = {
    EPSILON: (parcelRequire("53wU4")),
    create: (parcelRequire("czATl")),
    clone: (parcelRequire("ktIj8")),
    angle: (parcelRequire("fOLkG")),
    fromValues: (parcelRequire("5p9Yc")),
    copy: (parcelRequire("7Dzg4")),
    set: (parcelRequire("fo2vz")),
    equals: (parcelRequire("flAeI")),
    exactEquals: (parcelRequire("gdjm5")),
    add: (parcelRequire("dT84A")),
    subtract: (parcelRequire("8tXPc")),
    sub: (parcelRequire("eyNZt")),
    multiply: (parcelRequire("jIVHJ")),
    mul: (parcelRequire("9hvp4")),
    divide: (parcelRequire("lKeja")),
    div: (parcelRequire("hzBGt")),
    min: (parcelRequire("fFMqx")),
    max: (parcelRequire("OGbVP")),
    floor: (parcelRequire("cNkpn")),
    ceil: (parcelRequire("3lT8n")),
    round: (parcelRequire("P7vHj")),
    scale: (parcelRequire("82AuC")),
    scaleAndAdd: (parcelRequire("1fqWo")),
    distance: (parcelRequire("drpCB")),
    dist: (parcelRequire("67O7B")),
    squaredDistance: (parcelRequire("2AKAe")),
    sqrDist: (parcelRequire("lQ4tv")),
    length: (parcelRequire("kzdQp")),
    len: (parcelRequire("e23ro")),
    squaredLength: (parcelRequire("7MKk8")),
    sqrLen: (parcelRequire("2478D")),
    negate: (parcelRequire("du2VM")),
    inverse: (parcelRequire("9rLgR")),
    normalize: (parcelRequire("dKsAX")),
    dot: (parcelRequire("a5Tdg")),
    cross: (parcelRequire("4lH5K")),
    lerp: (parcelRequire("63k4I")),
    random: (parcelRequire("8F3Kv")),
    transformMat4: (parcelRequire("iHSWE")),
    transformMat3: (parcelRequire("9r5j4")),
    transformQuat: (parcelRequire("ZsAhZ")),
    rotateX: (parcelRequire("cUuOz")),
    rotateY: (parcelRequire("EIxCF")),
    rotateZ: (parcelRequire("ca2yO")),
    forEach: (parcelRequire("8s57t"))
};


const $f8a08dcd974d0e6a$var$computeCentroid = (vertices)=>{
    const sum = (0, $589baecd24708921$exports.create)();
    for(let i = 0; i < vertices.length; ++i)(0, $589baecd24708921$exports.add)(sum, sum, vertices[i]);
    (0, $589baecd24708921$exports.scale)(sum, sum, 1 / vertices.length);
    return sum;
};
var $f8a08dcd974d0e6a$export$2e2bcd8739ae039 = $f8a08dcd974d0e6a$var$computeCentroid;


var $fa2c703d63718fcd$exports = {};












































$fa2c703d63718fcd$exports = {
    EPSILON: (parcelRequire("9njAL")),
    create: (parcelRequire("5zrC4")),
    clone: (parcelRequire("dR9K4")),
    fromValues: (parcelRequire("8U8Cj")),
    copy: (parcelRequire("152Ae")),
    set: (parcelRequire("041RP")),
    equals: (parcelRequire("lUZQ8")),
    exactEquals: (parcelRequire("8PEWi")),
    add: (parcelRequire("7eHKC")),
    subtract: (parcelRequire("a405i")),
    sub: (parcelRequire("bHEVu")),
    multiply: (parcelRequire("0SrjJ")),
    mul: (parcelRequire("igZDQ")),
    divide: (parcelRequire("l77rB")),
    div: (parcelRequire("bQw8f")),
    inverse: (parcelRequire("2Qbdf")),
    min: (parcelRequire("cXe0w")),
    max: (parcelRequire("lRmZn")),
    rotate: (parcelRequire("gloPU")),
    floor: (parcelRequire("3IGrR")),
    ceil: (parcelRequire("87XTH")),
    round: (parcelRequire("8bnXh")),
    scale: (parcelRequire("io4QD")),
    scaleAndAdd: (parcelRequire("8EqqX")),
    distance: (parcelRequire("bsKoO")),
    dist: (parcelRequire("hekff")),
    squaredDistance: (parcelRequire("9RPI2")),
    sqrDist: (parcelRequire("5myqE")),
    length: (parcelRequire("8UVmo")),
    len: (parcelRequire("dXBRe")),
    squaredLength: (parcelRequire("6oVsU")),
    sqrLen: (parcelRequire("3joeB")),
    negate: (parcelRequire("1Vwt1")),
    normalize: (parcelRequire("l733a")),
    dot: (parcelRequire("28Qg1")),
    cross: (parcelRequire("fPhZb")),
    lerp: (parcelRequire("hUlg3")),
    random: (parcelRequire("5bERg")),
    transformMat2: (parcelRequire("iUq16")),
    transformMat2d: (parcelRequire("fsO2G")),
    transformMat3: (parcelRequire("ajhCe")),
    transformMat4: (parcelRequire("4bW1U")),
    forEach: (parcelRequire("6SlJ8")),
    limit: (parcelRequire("1icGa"))
};


const $d86620da02033ae7$var$computeControlOffset = (offset, vertex, prev, next)=>{
    (0, $fa2c703d63718fcd$exports.subtract)(offset, next, prev);
    (0, $fa2c703d63718fcd$exports.normalize)(offset, offset);
    (0, $fa2c703d63718fcd$exports.scale)(offset, offset, Math.min((0, $fa2c703d63718fcd$exports.distance)(prev, vertex), (0, $fa2c703d63718fcd$exports.distance)(prev, next), (0, $fa2c703d63718fcd$exports.distance)(vertex, next)));
    return offset;
};
const $d86620da02033ae7$var$serialize = (vertex)=>`${vertex[0]},${vertex[1]}`;
const $d86620da02033ae7$export$1ab0d92c212b37a6 = (vertices, smoothing)=>{
    const offset = (0, $fa2c703d63718fcd$exports.create)();
    const control = (0, $fa2c703d63718fcd$exports.create)();
    let end = '';
    const result = vertices.map((vertex, i)=>{
        const prev = vertices[(i + vertices.length - 1) % vertices.length];
        const next = vertices[(i + vertices.length + 1) % vertices.length];
        $d86620da02033ae7$var$computeControlOffset(offset, vertex, prev, next);
        (0, $fa2c703d63718fcd$exports.scaleAndAdd)(control, vertex, offset, -smoothing);
        if (i === 0) {
            end = `${$d86620da02033ae7$var$serialize(control)} ${$d86620da02033ae7$var$serialize(vertex)} Z`;
            (0, $fa2c703d63718fcd$exports.scaleAndAdd)(control, vertex, offset, smoothing);
            return `M ${$d86620da02033ae7$var$serialize(vertex)} C ${$d86620da02033ae7$var$serialize(control)}`;
        }
        return `${$d86620da02033ae7$var$serialize(control)} ${$d86620da02033ae7$var$serialize(vertex)} S`;
    });
    return result.join(' ') + ' ' + end;
};
const $d86620da02033ae7$export$595aab2af982e1d6 = (vertices, smoothing)=>{
    const control = (0, $fa2c703d63718fcd$exports.create)();
    const result = vertices.map((vertex, i)=>{
        if (i === 0) return `M ${$d86620da02033ae7$var$serialize(vertex)} C ${$d86620da02033ae7$var$serialize(vertex)}`;
        else if (i === vertices.length - 1) return `${$d86620da02033ae7$var$serialize(vertex)} ${$d86620da02033ae7$var$serialize(vertex)}`;
        const prev = vertices[(i + vertices.length - 1) % vertices.length];
        const next = vertices[(i + vertices.length + 1) % vertices.length];
        $d86620da02033ae7$var$computeControlOffset(control, vertex, prev, next);
        (0, $fa2c703d63718fcd$exports.scaleAndAdd)(control, vertex, control, -smoothing);
        return `${$d86620da02033ae7$var$serialize(control)} ${$d86620da02033ae7$var$serialize(vertex)} S`;
    });
    return result.join(' ');
};


const $10084b0da23f5c07$export$4b938d075d59879c = (name)=>document.createElementNS('http://www.w3.org/2000/svg', name);
var $10084b0da23f5c07$export$2e2bcd8739ae039 = $10084b0da23f5c07$export$4b938d075d59879c;


const $446e3c15142fd568$export$23007700f2a9aecf = (vertices, closed = false, smoothing = 1 / 3)=>{
    const path = (0, $10084b0da23f5c07$export$2e2bcd8739ae039)('path');
    const update = (project)=>{
        const projectedVertices = vertices.map((vertex)=>project(vertex)).filter(([, , , w])=>w > 0);
        path.setAttribute('d', closed ? (0, $d86620da02033ae7$export$1ab0d92c212b37a6)(projectedVertices, smoothing) : (0, $d86620da02033ae7$export$595aab2af982e1d6)(projectedVertices, smoothing));
    };
    const getCentroid = ()=>(0, $f8a08dcd974d0e6a$export$2e2bcd8739ae039)(vertices);
    return [
        path,
        update,
        getCentroid
    ];
};
var $446e3c15142fd568$export$2e2bcd8739ae039 = $446e3c15142fd568$export$23007700f2a9aecf;




const $799e53e71683ce28$export$184bb8159eb3eb47 = (vertex, children)=>{
    const group = (0, $10084b0da23f5c07$export$2e2bcd8739ae039)('g');
    const update = (project, cameraPosition)=>{
        const childrenWithDepth = children.map(([child, , getCentroid])=>[
                child,
                (0, $589baecd24708921$exports.distance)(cameraPosition, getCentroid())
            ]);
        const depthSortedChildren = childrenWithDepth.sort(([, depthA], [, depthB])=>depthB - depthA);
        depthSortedChildren.forEach(([child], i)=>{
            if (group.children[i] !== child) group.insertBefore(child, group.children[i]);
        });
        children.forEach(([, update])=>update(project, cameraPosition));
    };
    const getCentroid = ()=>vertex;
    return [
        group,
        update,
        getCentroid
    ];
};
var $799e53e71683ce28$export$2e2bcd8739ae039 = $799e53e71683ce28$export$184bb8159eb3eb47;





// based on https://en.wikipedia.org/wiki/Graham_scan
const $4e84940889c02390$var$computeCrossProductZ = ([x1, y1], [x2, y2], [x3, y3])=>{
    return (x2 - x1) * (y3 - y1) - (y2 - y1) * (x3 - x1);
};
const $4e84940889c02390$var$findOuterRoute = (sortedVertices)=>{
    const route = [];
    for(let i = 0; i < sortedVertices.length; ++i){
        const vertex = sortedVertices[i];
        while(route.length > 1 && $4e84940889c02390$var$computeCrossProductZ(route[route.length - 2], route[route.length - 1], vertex) > 0)route.pop();
        if (route.length === 0 || route[route.length - 1][0] !== vertex[0] || route[route.length - 1][1] !== vertex[1]) route.push(vertex);
    }
    return route;
};
const $4e84940889c02390$var$buildAngledPath = (vertices)=>{
    return `M ${vertices.map(([x, y])=>`${x},${y}`).join(' L ')} Z`;
};
const $4e84940889c02390$export$32928b00d6f6bffd = (vertices, smoothing = 1 / 3)=>{
    const path = (0, $10084b0da23f5c07$export$2e2bcd8739ae039)('path');
    const update = (project)=>{
        const projectedVertices = vertices.map((vertex)=>project(vertex)).filter(([, , , w])=>w > 0);
        const sortedVertices = projectedVertices.sort(([x1, y1], [x2, y2])=>x1 !== x2 ? x1 - x2 : y1 - y2);
        const routeA = $4e84940889c02390$var$findOuterRoute(sortedVertices);
        sortedVertices.reverse();
        const routeB = $4e84940889c02390$var$findOuterRoute(sortedVertices);
        routeA.pop();
        routeB.pop();
        const route = [
            ...routeA,
            ...routeB
        ];
        path.setAttribute('d', smoothing ? (0, $d86620da02033ae7$export$1ab0d92c212b37a6)(route, smoothing) : $4e84940889c02390$var$buildAngledPath(route));
    };
    const getCentroid = ()=>(0, $f8a08dcd974d0e6a$export$2e2bcd8739ae039)(vertices);
    return [
        path,
        update,
        getCentroid
    ];
};
var $4e84940889c02390$export$2e2bcd8739ae039 = $4e84940889c02390$export$32928b00d6f6bffd;




const $4e5be12e7af4f13a$export$2b0a6dbbe53f55c6 = (from, to)=>{
    const line = (0, $10084b0da23f5c07$export$2e2bcd8739ae039)('line');
    const updatePoints = (project)=>{
        const [x1, y1] = project(from);
        line.setAttribute('x1', x1);
        line.setAttribute('y1', y1);
        const [x2, y2] = project(to);
        line.setAttribute('x2', x2);
        line.setAttribute('y2', y2);
    };
    const getCentroid = ()=>(0, $f8a08dcd974d0e6a$export$2e2bcd8739ae039)([
            from,
            to
        ]);
    return [
        line,
        updatePoints,
        getCentroid
    ];
};
var $4e5be12e7af4f13a$export$2e2bcd8739ae039 = $4e5be12e7af4f13a$export$2b0a6dbbe53f55c6;




const $4935f48e4048ca6e$export$aa9bab72412f5613 = (commands)=>{
    const path = (0, $10084b0da23f5c07$export$2e2bcd8739ae039)('path');
    const updatePoints = (project)=>{
        path.setAttribute('d', commands.map((item)=>{
            if (typeof item === 'string') return item;
            const [x, y] = project(item);
            return `${x},${y}`;
        }).join(' '));
    };
    const getCentroid = ()=>(0, $f8a08dcd974d0e6a$export$2e2bcd8739ae039)(commands.filter((item)=>typeof item !== 'string'));
    return [
        path,
        updatePoints,
        getCentroid
    ];
};
var $4935f48e4048ca6e$export$2e2bcd8739ae039 = $4935f48e4048ca6e$export$aa9bab72412f5613;




const $7c41cf9c679663d8$export$1210e559bc79903d = (vertices)=>{
    const polygon = (0, $10084b0da23f5c07$export$2e2bcd8739ae039)('polygon');
    const updatePoints = (project)=>{
        polygon.setAttribute('points', vertices.map((vertex)=>{
            const [x, y] = project(vertex);
            return `${x},${y}`;
        }).join(' '));
    };
    const getCentroid = ()=>(0, $f8a08dcd974d0e6a$export$2e2bcd8739ae039)(vertices);
    return [
        polygon,
        updatePoints,
        getCentroid
    ];
};
var $7c41cf9c679663d8$export$2e2bcd8739ae039 = $7c41cf9c679663d8$export$1210e559bc79903d;




const $9157364bde1d5b32$export$e23317381f8f16af = (vertices)=>{
    const polyline = (0, $10084b0da23f5c07$export$2e2bcd8739ae039)('polyline');
    const updatePoints = (project)=>{
        polyline.setAttribute('points', vertices.reduce((points, vertex)=>{
            const [x, y, z, w] = project(vertex);
            if (w > 0) return `${points} ${x},${y}`;
            return points;
        }, ''));
    };
    const getCentroid = ()=>(0, $f8a08dcd974d0e6a$export$2e2bcd8739ae039)(vertices);
    return [
        polyline,
        updatePoints,
        getCentroid
    ];
};
var $9157364bde1d5b32$export$2e2bcd8739ae039 = $9157364bde1d5b32$export$e23317381f8f16af;


var $84454aa379914692$exports = {};

$84454aa379914692$exports = (parcelRequire("5UFnH"));




const $df082aa08ed5892b$export$c03da5d65ddac336 = (width, height, objects)=>{
    const camera = (0, (/*@__PURE__*/$parcel$interopDefault($84454aa379914692$exports)))({
        viewport: [
            0,
            0,
            width,
            height
        ]
    });
    const svg = (0, $10084b0da23f5c07$export$2e2bcd8739ae039)('svg');
    svg.setAttribute('viewBox', camera.viewport.join(' '));
    const [rootGroup, updateRoot] = (0, $799e53e71683ce28$export$2e2bcd8739ae039)([
        0,
        0,
        0
    ], objects);
    rootGroup.setAttribute('transform', `translate(${width / 2}, ${height / 2}) scale(-1, -1) translate(-${width / 2}, -${height / 2})`);
    svg.appendChild(rootGroup);
    const update = ()=>{
        camera.update();
        updateRoot((vertex)=>camera.project(vertex), camera.position);
    };
    return [
        svg,
        camera,
        update
    ];
};
var $df082aa08ed5892b$export$2e2bcd8739ae039 = $df082aa08ed5892b$export$c03da5d65ddac336;


var $c9f30d8a40b61106$exports = {};





























$c9f30d8a40b61106$exports = {
    create: (parcelRequire("fW4F6")),
    clone: (parcelRequire("iBqKq")),
    copy: (parcelRequire("izCn0")),
    identity: (parcelRequire("8z9vI")),
    transpose: (parcelRequire("8q2JF")),
    invert: (parcelRequire("i9qJL")),
    adjoint: (parcelRequire("9VokK")),
    determinant: (parcelRequire("1GN8q")),
    multiply: (parcelRequire("1m04l")),
    translate: (parcelRequire("kAYus")),
    scale: (parcelRequire("9IQUq")),
    rotate: (parcelRequire("2HmzD")),
    rotateX: (parcelRequire("cDXxV")),
    rotateY: (parcelRequire("9yOYc")),
    rotateZ: (parcelRequire("jw0rw")),
    fromRotation: (parcelRequire("grshU")),
    fromRotationTranslation: (parcelRequire("3dVn9")),
    fromScaling: (parcelRequire("aYB92")),
    fromTranslation: (parcelRequire("3ugVX")),
    fromXRotation: (parcelRequire("kxUBr")),
    fromYRotation: (parcelRequire("9zaKy")),
    fromZRotation: (parcelRequire("9s3HV")),
    fromQuat: (parcelRequire("jPLYo")),
    frustum: (parcelRequire("dkigV")),
    perspective: (parcelRequire("ikIaj")),
    perspectiveFromFieldOfView: (parcelRequire("5Aand")),
    ortho: (parcelRequire("8yCJQ")),
    lookAt: (parcelRequire("gNfAP")),
    str: (parcelRequire("9QbSM"))
};



const $60b5ed68af967d92$export$c031337be25bf9eb = ([child, updateChild, getChildCentroid], transform)=>{
    const transformedVec3 = (0, $589baecd24708921$exports.create)();
    const invertedMat4 = (0, $c9f30d8a40b61106$exports.create)();
    const update = (project, cameraPosition)=>{
        const transformProject = (vec3)=>{
            (0, $589baecd24708921$exports.transformMat4)(transformedVec3, vec3, transform);
            return project(transformedVec3);
        };
        (0, $c9f30d8a40b61106$exports.invert)(invertedMat4, transform);
        (0, $589baecd24708921$exports.transformMat4)(transformedVec3, cameraPosition, invertedMat4);
        updateChild(transformProject, transformedVec3);
    };
    const getCentroid = ()=>{
        const centroid = getChildCentroid();
        (0, $589baecd24708921$exports.transformMat4)(transformedVec3, centroid, transform);
        return transformedVec3;
    };
    return [
        child,
        update,
        getCentroid
    ];
};
var $60b5ed68af967d92$export$2e2bcd8739ae039 = $60b5ed68af967d92$export$c031337be25bf9eb;







var $3kW6u = parcelRequire("3kW6u");

var $fjfo2 = parcelRequire("fjfo2");

var $5196a89362e95149$exports = {};

var $dKsAX = parcelRequire("dKsAX");

var $8tXPc = parcelRequire("8tXPc");

var $4lH5K = parcelRequire("4lH5K");
var $5196a89362e95149$var$tmp = [
    0,
    0,
    0
];
$5196a89362e95149$exports = $5196a89362e95149$var$planeNormal;
function $5196a89362e95149$var$planeNormal(out, point1, point2, point3) {
    $8tXPc(out, point1, point2);
    $8tXPc($5196a89362e95149$var$tmp, point2, point3);
    $4lH5K(out, out, $5196a89362e95149$var$tmp);
    return $dKsAX(out, out);
}



var $4yX4d = parcelRequire("4yX4d");

const $806cd3fd01d2a855$var$makeTerrain = (triangles)=>{
    const floors = triangles.filter((triangle)=>(0, (/*@__PURE__*/$parcel$interopDefault($5196a89362e95149$exports)))([], ...triangle)[1] > 0);
    const walls = triangles.filter((triangle)=>(0, (/*@__PURE__*/$parcel$interopDefault($5196a89362e95149$exports)))([], ...triangle)[1] === 0);
    const group = triangles.map((triangle)=>{
        const normal = (0, (/*@__PURE__*/$parcel$interopDefault($5196a89362e95149$exports)))([], ...triangle);
        const poly = (0, $4e84940889c02390$export$32928b00d6f6bffd)(triangle, 0);
        if (normal[1] > 0) poly[0].setAttribute('class', 'terrain floor');
        else if (normal[1] < 0) poly[0].setAttribute('class', 'terrain ceiling');
        else poly[0].setAttribute('class', 'terrain wall');
        return poly;
    });
    const getFloorIntersection = (origin, backtrack)=>{
        const direction = [
            0,
            -1,
            0
        ];
        const hit = [];
        let result = {
            distance: Infinity
        };
        for (let triangle of floors)if ((0, (/*@__PURE__*/$parcel$interopDefault($4yX4d)))(hit, origin, direction, triangle)) {
            const distance = origin[1] - hit[1];
            if (distance > -backtrack && distance < result.distance) {
                const normal = (0, (/*@__PURE__*/$parcel$interopDefault($5196a89362e95149$exports)))([], ...triangle);
                result = {
                    triangle: triangle,
                    hit: (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).clone(hit),
                    normal: normal,
                    distance: distance
                };
            }
        }
        return result;
    };
    const getWallIntersection = (origin, backtrack)=>{
        const hit = [];
        let result = {
            distance: Infinity
        };
        const temp = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).create();
        for (let triangle of walls){
            const normal = (0, (/*@__PURE__*/$parcel$interopDefault($5196a89362e95149$exports)))([], ...triangle);
            const fakeOrigin = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).scaleAndAdd([], origin, normal, backtrack);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($4yX4d)))(hit, fakeOrigin, (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).negate([], normal), triangle)) {
                const offset = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).subtract(temp, fakeOrigin, hit);
                const distance = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).dot(offset, normal) - backtrack;
                if (distance > -backtrack && distance < result.distance) result = {
                    triangle: triangle,
                    hit: (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).clone(hit),
                    normal: normal,
                    distance: distance
                };
            }
        }
        return result;
    };
    return [
        group,
        getFloorIntersection,
        getWallIntersection
    ];
};
var $806cd3fd01d2a855$export$2e2bcd8739ae039 = $806cd3fd01d2a855$var$makeTerrain;







const $e3be51b05840559d$export$1f86b2e9d01bdf1e = (val, dt = 1)=>1 - Math.pow(1 - val, dt);
const $e3be51b05840559d$export$3a89f8d6f6bf6c9f = (from, to, val, dt = 1)=>from + (to - from) * $e3be51b05840559d$export$1f86b2e9d01bdf1e(val, dt);
const $e3be51b05840559d$export$be967d79ba2e1f9f = (from, to, val, dt = 1)=>{
    if (to - from > Math.PI) from += 2 * Math.PI;
    if (to - from < -Math.PI) from -= 2 * Math.PI;
    return $e3be51b05840559d$export$3a89f8d6f6bf6c9f(from, to, val, dt);
};
const $e3be51b05840559d$export$1862c4a75de37b20 = (vec2, to, val, dt = 1)=>(0, (/*@__PURE__*/$parcel$interopDefault($fa2c703d63718fcd$exports))).lerp(vec2, vec2, to, $e3be51b05840559d$export$1f86b2e9d01bdf1e(val, dt));
const $e3be51b05840559d$export$2a33e9eedc5edac3 = (vec3, to, val, dt = 1)=>(0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).lerp(vec3, vec3, to, $e3be51b05840559d$export$1f86b2e9d01bdf1e(val, dt));







const $68378aa50777e53f$var$makeCircleOfPoints = (radius, height, count)=>{
    return [
        ...Array(count).keys()
    ].map((i)=>{
        const angle = 2 * Math.PI * i / count;
        return [
            Math.sin(angle) * radius,
            height,
            Math.cos(angle) * radius
        ];
    });
};
const $68378aa50777e53f$var$makeLeg = ()=>{
    const leg = (0, $4e5be12e7af4f13a$export$2b0a6dbbe53f55c6)([
        0,
        -1,
        0
    ], [
        0,
        -0.3,
        0
    ]);
    const leftToe = (0, $4e5be12e7af4f13a$export$2b0a6dbbe53f55c6)([
        0,
        -1,
        0
    ], [
        -0.15,
        -1,
        0.25
    ]);
    const middleToe = (0, $4e5be12e7af4f13a$export$2b0a6dbbe53f55c6)([
        0,
        -1,
        0
    ], [
        0,
        -1,
        0.35
    ]);
    const rightToe = (0, $4e5be12e7af4f13a$export$2b0a6dbbe53f55c6)([
        0,
        -1,
        0
    ], [
        0.15,
        -1,
        0.25
    ]);
    const group = (0, $799e53e71683ce28$export$184bb8159eb3eb47)([
        0,
        0,
        0
    ], [
        leg,
        leftToe,
        middleToe,
        rightToe
    ]);
    return (0, $60b5ed68af967d92$export$c031337be25bf9eb)(group, (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).fromTranslation([], [
        0.2,
        0,
        0
    ]));
};
const $68378aa50777e53f$var$makeEgg = ()=>{
    const count = 8;
    const egg = (0, $4e84940889c02390$export$32928b00d6f6bffd)([
        [
            0,
            -1,
            0
        ],
        ...[
            ...Array(count).keys()
        ].map((i)=>{
            const angle = Math.PI / 2 * (i / count);
            return $68378aa50777e53f$var$makeCircleOfPoints(Math.cos(angle), -Math.sin(angle), 16);
        }).flat(),
        ...[
            ...Array(count).keys()
        ].map((i)=>{
            const angle = Math.PI / 2 * (i / count);
            return $68378aa50777e53f$var$makeCircleOfPoints(Math.cos(angle), Math.sin(angle) * 1.5, 16);
        }).flat(),
        [
            0,
            1.5,
            0
        ]
    ]);
    egg[0].setAttribute('fill', 'whitesmoke');
    return (0, $60b5ed68af967d92$export$c031337be25bf9eb)(egg, (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).fromTranslation([], [
        0,
        1.7,
        0
    ]));
};
const $68378aa50777e53f$var$makeEye = ()=>{
    const eye = (0, $799e53e71683ce28$export$184bb8159eb3eb47)([
        0,
        0,
        0
    ], [
        (0, $4e84940889c02390$export$32928b00d6f6bffd)([
            ...$68378aa50777e53f$var$makeCircleOfPoints(0.3, 0, 12),
            ...$68378aa50777e53f$var$makeCircleOfPoints(0.3, 0.1, 12),
            ...$68378aa50777e53f$var$makeCircleOfPoints(0.325, 0.05, 12),
            ...$68378aa50777e53f$var$makeCircleOfPoints(0.25, 0, 8).map(([x, y, z])=>[
                    x,
                    y,
                    z + 0.1
                ]),
            ...$68378aa50777e53f$var$makeCircleOfPoints(0.25, 0.1, 8).map(([x, y, z])=>[
                    x,
                    y,
                    z + 0.1
                ]),
            ...$68378aa50777e53f$var$makeCircleOfPoints(0.275, 0.05, 8).map(([x, y, z])=>[
                    x,
                    y,
                    z + 0.1
                ])
        ])
    ]);
    eye[0].setAttribute('fill', 'white');
    const pupil = (0, $799e53e71683ce28$export$184bb8159eb3eb47)([
        0,
        0,
        0
    ], [
        (0, $4e84940889c02390$export$32928b00d6f6bffd)($68378aa50777e53f$var$makeCircleOfPoints(0.1, 0.04, 6))
    ]);
    pupil[0].setAttribute('fill', 'black');
    return (0, $60b5ed68af967d92$export$c031337be25bf9eb)((0, $799e53e71683ce28$export$184bb8159eb3eb47)([
        0,
        0,
        0
    ], [
        eye,
        pupil
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).fromRotation([], -Math.PI / 2, [
        1,
        0,
        0
    ]));
};
const $68378aa50777e53f$var$makePlayer = (getFloorIntersection, getWallIntersection)=>{
    const egg = $68378aa50777e53f$var$makeEgg();
    const leftLegTransform = (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).create();
    const leftLeg = (0, $60b5ed68af967d92$export$c031337be25bf9eb)($68378aa50777e53f$var$makeLeg(), leftLegTransform);
    const rightLegTransform = (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).create();
    const rightLeg = (0, $60b5ed68af967d92$export$c031337be25bf9eb)($68378aa50777e53f$var$makeLeg(), rightLegTransform);
    const leftEyeTransform = (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).fromTranslation([], [
        0.25,
        2.5,
        0.8
    ]);
    const leftEye = (0, $60b5ed68af967d92$export$c031337be25bf9eb)($68378aa50777e53f$var$makeEye(), leftEyeTransform);
    const rightEyeTransform = (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).fromTranslation([], [
        -0.25,
        2.5,
        0.8
    ]);
    const rightEye = (0, $60b5ed68af967d92$export$c031337be25bf9eb)($68378aa50777e53f$var$makeEye(), rightEyeTransform);
    const shadowTransform = (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).create();
    const shadow = (0, $60b5ed68af967d92$export$c031337be25bf9eb)((0, $4e84940889c02390$export$32928b00d6f6bffd)($68378aa50777e53f$var$makeCircleOfPoints(1, 0, 8)), shadowTransform);
    shadow[0].setAttribute('fill', 'black');
    shadow[0].setAttribute('opacity', 0);
    const group = (0, $799e53e71683ce28$export$184bb8159eb3eb47)([
        0,
        3,
        0
    ], [
        shadow,
        leftLeg,
        rightLeg,
        egg,
        leftEye,
        rightEye
    ]);
    const transform = (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).create();
    const player = (0, $60b5ed68af967d92$export$c031337be25bf9eb)(group, transform);
    player[0].setAttribute('stroke', 'black');
    player[0].setAttribute('stroke-width', 3);
    return [
        player,
        {
            base: transform,
            leftLeg: leftLegTransform,
            rightLeg: rightLegTransform,
            shadow: shadowTransform,
            setShadowOpacity: (opacity)=>shadow[0].setAttribute('opacity', opacity)
        }
    ];
};
var $68378aa50777e53f$export$2e2bcd8739ae039 = $68378aa50777e53f$var$makePlayer;





const $8fb4ae3a622701ca$var$makeGroundedState = (getFloorIntersection, getWallIntersection)=>{
    const initialState = {
        groundedTime: 0.1,
        skidTime: 0
    };
    const update = (state, dt, { movement: movement, jump: jump })=>{
        const lastPosition = state.position;
        state.position = $589baecd24708921$exports.clone(state.position);
        state.velocity = $589baecd24708921$exports.clone(state.velocity);
        // determine how fast the player wants to go and their accel
        const desiredVelocity = $589baecd24708921$exports.create();
        const maxSpeed = Math.max($589baecd24708921$exports.length(state.velocity), 12);
        let maxAccel = 20 * dt;
        if ($fa2c703d63718fcd$exports.length(movement) > 0.1) {
            state.skidTime -= dt;
            $589baecd24708921$exports.set(desiredVelocity, movement[0], 0, movement[1]);
            if ($589baecd24708921$exports.length(state.velocity) > 3 && $589baecd24708921$exports.angle(desiredVelocity, state.velocity) > 0.45 * Math.PI) {
                state.skidTime = 0.25;
                maxAccel = 40 * dt;
            }
            const targetFacing = Math.atan2(movement[0], movement[1]);
            state.facing = (0, $e3be51b05840559d$export$be967d79ba2e1f9f)(state.facing, targetFacing, 0.1, dt * 60);
        } else {
            maxAccel = 30 * dt;
            state.skidTime = 0;
        }
        $589baecd24708921$exports.scale(desiredVelocity, desiredVelocity, maxSpeed);
        // accel towards the desired velocity without moving past it
        if ($589baecd24708921$exports.distance(state.velocity, desiredVelocity) > maxAccel) {
            const accel = $589baecd24708921$exports.subtract([], desiredVelocity, state.velocity);
            $589baecd24708921$exports.normalize(accel, accel);
            $589baecd24708921$exports.scaleAndAdd(state.velocity, state.velocity, accel, maxAccel);
        } else $589baecd24708921$exports.copy(state.velocity, desiredVelocity);
        if ($589baecd24708921$exports.length(state.velocity) > maxSpeed) {
            $589baecd24708921$exports.normalize(state.velocity, state.velocity);
            $589baecd24708921$exports.scale(state.velocity, state.velocity, maxSpeed);
        }
        // walk animation
        state.walk += $589baecd24708921$exports.length(state.velocity) * dt;
        state.walkScale = (0, $e3be51b05840559d$export$3a89f8d6f6bf6c9f)(state.walkScale, $589baecd24708921$exports.length(state.velocity) / 10, 0.3, dt * 60);
        state.velocity[1] = 0;
        $589baecd24708921$exports.scaleAndAdd(state.position, state.position, state.velocity, dt);
        const wall = getWallIntersection($589baecd24708921$exports.add([], state.position, [
            0,
            2,
            0
        ]), 0.5);
        if (wall.hit && wall.distance < 1) {
            $589baecd24708921$exports.scaleAndAdd(state.position, state.position, wall.normal, 1 - wall.distance);
            const scale = Math.max(-Math.cos($589baecd24708921$exports.angle(state.velocity, wall.normal)), 0);
            $589baecd24708921$exports.scaleAndAdd(state.velocity, state.velocity, wall.normal, $589baecd24708921$exports.length(state.velocity) * scale);
            const normal2d = $fa2c703d63718fcd$exports.fromValues(wall.normal[0], wall.normal[2]);
            if ($fa2c703d63718fcd$exports.dot(movement, normal2d) < -0.95) {
                $589baecd24708921$exports.set(state.velocity, 0, 0, 0);
                $589baecd24708921$exports.copy(state.position, lastPosition);
            }
        }
        const floor = getFloorIntersection(state.position, 1.5);
        if (floor.hit) {
            if (floor.distance < 1.5) {
                state.groundedTime = Math.max(0.1, dt);
                $589baecd24708921$exports.copy(state.position, floor.hit);
            }
            state.shadowNormal = floor.normal;
            state.shadowDistance = state.position[1] - floor.hit[1];
        } else {
            $589baecd24708921$exports.copy(state.position, lastPosition);
            $589baecd24708921$exports.set(state.velocity, 0, 0, 0);
        }
        state.groundedTime -= dt;
        if (state.groundedTime < 0) state.mode = 'jumping';
        // jumping
        if (!state.jumped && jump) {
            state.skidTime = 0;
            if (state.skidTime > 0) {
                state.mode = 'skidjumping';
                $589baecd24708921$exports.set(state.velocity, 0, 25, 0);
            } else {
                state.mode = 'jumping';
                state.velocity[1] = 13 + 0.2 * $fa2c703d63718fcd$exports.length([
                    state.velocity[0],
                    state.velocity[2]
                ]);
            }
            state.jumped = true;
        } else if (!jump) state.jumped = false;
        return state;
    };
    return {
        initialState: initialState,
        update: update
    };
};
var $8fb4ae3a622701ca$export$2e2bcd8739ae039 = $8fb4ae3a622701ca$var$makeGroundedState;





const $b11da181245e7230$var$makeJumpingState = (getFloorIntersection, getWallIntersection)=>{
    const initialState = {
        skidJump: false
    };
    const update = (state, dt, { movement: movement, jump: jump })=>{
        const lastPosition = state.position;
        state.position = $589baecd24708921$exports.clone(state.position);
        state.velocity = $589baecd24708921$exports.clone(state.velocity);
        let floatBonus = 0;
        // apply gravity
        state.velocity[1] -= 55 * dt;
        // hold jump in the air to glide
        /*
    const floatSpeed = Math.min(-20 + Vec2.length([state.velocity[0], state.velocity[2]]) * 2, -1);
    if (jump && state.velocity[1] <= floatSpeed) {
      state.velocity[1] = Math.min(floatSpeed, state.velocity[1] + 75*dt);
      floatBonus = floatSpeed - state.velocity[1];
      if (floatSpeed - state.velocity[1] < 1) {
        state.jumped = true;
      }
      const targetFacing = Math.atan2(state.velocity[0], state.velocity[2]);
      state.facing = lerpAngle(state.facing, targetFacing, 0.05, dt*60);
    }
    */ // apply accel but keep a max horizontal speed
        if ($fa2c703d63718fcd$exports.length(movement) > 0.1) {
            const velocity2d = $fa2c703d63718fcd$exports.fromValues(state.velocity[0], state.velocity[2]);
            const flatSpeed = $fa2c703d63718fcd$exports.length(velocity2d);
            const maxSpeed = Math.max(flatSpeed, 6 + floatBonus);
            if (flatSpeed >= maxSpeed) $fa2c703d63718fcd$exports.scale(velocity2d, velocity2d, (flatSpeed - 14 * $fa2c703d63718fcd$exports.length(movement) * dt) / flatSpeed);
            $fa2c703d63718fcd$exports.scaleAndAdd(velocity2d, velocity2d, movement, (15 + floatBonus) * dt);
            if ($fa2c703d63718fcd$exports.length(velocity2d) > maxSpeed) {
                $fa2c703d63718fcd$exports.normalize(velocity2d, velocity2d);
                $fa2c703d63718fcd$exports.scale(velocity2d, velocity2d, maxSpeed);
            }
            // switch back to 3d
            state.velocity[0] = velocity2d[0];
            state.velocity[2] = velocity2d[1];
        }
        // hold jump to float higher
        if (jump && state.jumped && state.velocity[1] > 5) state.velocity[1] += 40 * dt;
        // reset the jump button
        if (!jump && state.velocity[1] <= 0) state.jumped = false;
        // jumping legs animation
        state.walk = (0, $e3be51b05840559d$export$be967d79ba2e1f9f)(state.walk, 1.5 * Math.PI, 0.1, dt * 60);
        state.walkScale = (0, $e3be51b05840559d$export$3a89f8d6f6bf6c9f)(state.walkScale, Math.min(Math.max(state.velocity[1] / 10, -1), 1), 0.1, dt * 60);
        $589baecd24708921$exports.scaleAndAdd(state.position, state.position, state.velocity, dt);
        const wall = getWallIntersection($589baecd24708921$exports.add([], state.position, [
            0,
            2,
            0
        ]), 0.5);
        if (wall.hit && wall.distance < 1) {
            $589baecd24708921$exports.scaleAndAdd(state.position, state.position, wall.normal, 1 - wall.distance);
            const bounce = false;
            if (bounce) $589baecd24708921$exports.scaleAndAdd([], state.velocity, wall.normal, -2 * $589baecd24708921$exports.dot(state.velocity, wall.normal));
            else {
                const scale = Math.max(-Math.cos($589baecd24708921$exports.angle(state.velocity, wall.normal)), 0);
                $589baecd24708921$exports.scaleAndAdd([], state.velocity, wall.normal, $589baecd24708921$exports.length(state.velocity) * scale);
            }
        }
        const floor = getFloorIntersection(state.position, 2);
        if (floor.hit) {
            if (floor.distance <= 0 && state.velocity[1] < 0) {
                $589baecd24708921$exports.copy(state.position, floor.hit);
                state.mode = 'grounded';
            }
            state.shadowNormal = floor.normal;
            state.shadowDistance = state.position[1] - floor.hit[1];
        } else {
            $589baecd24708921$exports.set(state.velocity, -state.velocity[0], Math.min(Math.max(state.velocity[1], -20), 5), -state.velocity[2]);
            $589baecd24708921$exports.copy(state.position, lastPosition);
        }
        return state;
    };
    return {
        initialState: initialState,
        update: update
    };
};
var $b11da181245e7230$export$2e2bcd8739ae039 = $b11da181245e7230$var$makeJumpingState;





const $adc6faea12bdb28d$var$makeSkidJumpingState = (getFloorIntersection, getWallIntersection)=>{
    const initialState = {};
    const update = (state, dt, { movement: movement, jump: jump })=>{
        const lastPosition = state.position;
        state.position = $589baecd24708921$exports.clone(state.position);
        state.velocity = $589baecd24708921$exports.clone(state.velocity);
        // apply gravity
        state.velocity[1] -= 30 * dt;
        // apply accel but keep a max horizontal speed
        if ($fa2c703d63718fcd$exports.length(movement) > 0.1) {
            const velocity2d = $fa2c703d63718fcd$exports.fromValues(state.velocity[0], state.velocity[2]);
            const maxSpeed = Math.max($fa2c703d63718fcd$exports.length(velocity2d), 20);
            $fa2c703d63718fcd$exports.scaleAndAdd(velocity2d, velocity2d, movement, 20 * dt);
            if ($fa2c703d63718fcd$exports.length(velocity2d) > maxSpeed) {
                $fa2c703d63718fcd$exports.normalize(velocity2d, velocity2d);
                $fa2c703d63718fcd$exports.scale(velocity2d, velocity2d, maxSpeed);
            }
            // switch back to 3d
            state.velocity[0] = velocity2d[0];
            state.velocity[2] = velocity2d[1];
        }
        // jumping legs animation
        state.walk += state.velocity[1] * dt;
        state.walkScale = (0, $e3be51b05840559d$export$3a89f8d6f6bf6c9f)(state.walkScale, Math.min(Math.max(state.velocity[1] / 10, -1), 1), 0.1, dt * 60);
        $589baecd24708921$exports.scaleAndAdd(state.position, state.position, state.velocity, dt);
        const wall = getWallIntersection($589baecd24708921$exports.add([], state.position, [
            0,
            2,
            0
        ]), 0.5);
        if (wall.hit && wall.distance < 1) {
            $589baecd24708921$exports.scaleAndAdd(state.position, state.position, wall.normal, 1 - wall.distance);
            $589baecd24708921$exports.scaleAndAdd([], state.velocity, wall.normal, -2 * $589baecd24708921$exports.dot(state.velocity, wall.normal));
        }
        const floor = getFloorIntersection(state.position, 2);
        if (floor.hit) {
            state.shadowNormal = floor.normal;
            state.shadowDistance = state.position[1] - floor.hit[1];
        } else {
            state.mode = 'jumping';
            $589baecd24708921$exports.copy(state.position, lastPosition);
        }
        if (state.velocity[1] <= 0) state.mode = 'jumping';
        return state;
    };
    return {
        initialState: initialState,
        update: update
    };
};
var $adc6faea12bdb28d$export$2e2bcd8739ae039 = $adc6faea12bdb28d$var$makeSkidJumpingState;


const $1b5e89835ea262cf$var$makePlayer = (getFloorIntersection, getWallIntersection)=>{
    const [svg, svgData] = (0, $68378aa50777e53f$export$2e2bcd8739ae039)();
    const modes = {
        'grounded': (0, $8fb4ae3a622701ca$export$2e2bcd8739ae039)(getFloorIntersection, getWallIntersection),
        'jumping': (0, $b11da181245e7230$export$2e2bcd8739ae039)(getFloorIntersection, getWallIntersection),
        'skidjumping': (0, $adc6faea12bdb28d$export$2e2bcd8739ae039)(getFloorIntersection, getWallIntersection)
    };
    const initialState = Object.values(modes).reduce((accum, { initialState: initialState })=>({
            ...accum,
            ...initialState
        }), {
        mode: 'grounded',
        position: (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).create(),
        velocity: (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).create(),
        facing: 0,
        jumped: false,
        shadowNormal: (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).fromValues(0, 1, 0),
        shadowDistance: 0,
        walk: 0,
        walkScale: 0
    });
    const update = (state, dt, input)=>{
        const lastMode = state.mode;
        state = modes[state.mode].update(state, dt, input);
        // reset the previous mode when entering a new one
        if (state.mode !== lastMode) Object.assign(state, modes[lastMode].initialState);
        return state;
    };
    const interpolate = (state, nextState, factor)=>{
        const { base: base, leftLeg: leftLeg, rightLeg: rightLeg, shadow: shadow, setShadowOpacity: setShadowOpacity } = svgData;
        const position = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).lerp([], state.position, nextState.position, factor);
        const facing = (0, $e3be51b05840559d$export$be967d79ba2e1f9f)(state.facing, nextState.facing, factor);
        const shadowNormal = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).lerp([], state.shadowNormal, nextState.shadowNormal, factor);
        const shadowDistance = (0, $e3be51b05840559d$export$3a89f8d6f6bf6c9f)(state.shadowDistance, nextState.shadowDistance, factor);
        const shadowIntensity = 1 / ((shadowDistance + 5) / 5);
        (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).fromRotation(base, facing, [
            0,
            1,
            0
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).transformMat4(shadowNormal, shadowNormal, (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).invert([], base));
        (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).multiply(base, (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).fromTranslation([], position), base);
        const shadowScale = Math.pow(shadowIntensity, 2 / 3);
        (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).lookAt(shadow, [
            0,
            0,
            0
        ], [
            0,
            -shadowNormal[2],
            shadowNormal[1]
        ], shadowNormal);
        (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).scale(shadow, shadow, [
            shadowScale,
            shadowScale,
            shadowScale
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).multiply(shadow, (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).fromTranslation([], [
            0,
            -shadowDistance,
            0
        ]), shadow);
        setShadowOpacity(0.3 * shadowIntensity);
        (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).fromTranslation(leftLeg, [
            0,
            1,
            0
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).fromTranslation(rightLeg, [
            0,
            1,
            0
        ]);
        const angle = Math.sin((0, $e3be51b05840559d$export$be967d79ba2e1f9f)(state.walk, nextState.walk, factor)) * (0, $e3be51b05840559d$export$3a89f8d6f6bf6c9f)(state.walkScale, nextState.walkScale, factor);
        (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).rotateX(leftLeg, leftLeg, -angle);
        (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).rotateX(rightLeg, rightLeg, angle);
        (0, (/*@__PURE__*/$parcel$interopDefault($c9f30d8a40b61106$exports))).scale(leftLeg, leftLeg, [
            -1,
            1,
            1
        ]);
    };
    return [
        svg,
        update,
        initialState,
        interpolate
    ];
};
var $1b5e89835ea262cf$export$2e2bcd8739ae039 = $1b5e89835ea262cf$var$makePlayer;


/*!
 * Contro
 * (c) 2020 Niklas Higi
 * Released under the MIT License.
 */ const $e430c512453d3000$var$store = {
    preferGamepad: false
};
class $e430c512453d3000$var$Vector2 {
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
}
const $e430c512453d3000$var$mouseButtons = [
    'left',
    'middle',
    'right'
];
class $e430c512453d3000$export$7caecd373b84cec3 {
    constructor({ canvas: canvas, doc: doc }){
        this.pointerMovement = new $e430c512453d3000$var$Vector2();
        this.pressedButtons = new Set();
        this.queuedButtons = new Set();
        this.scrollDistance = 0;
        this.canvas = canvas;
        this.document = doc !== null && doc !== void 0 ? doc : document;
        const on = this.canvas.addEventListener.bind(this.canvas);
        on('mousedown', (event)=>{
            $e430c512453d3000$var$store.preferGamepad = false;
            this.pressedButtons.add(event.button);
            this.queuedButtons.add(event.button);
        });
        on('mouseup', (event)=>{
            $e430c512453d3000$var$store.preferGamepad = false;
            this.pressedButtons.delete(event.button);
            this.queuedButtons.delete(event.button);
        });
        on('mousemove', (event)=>{
            $e430c512453d3000$var$store.preferGamepad = false;
            this.pointerMovement.x += event.movementX;
            this.pointerMovement.y += event.movementY;
        });
        on('wheel', (event)=>{
            $e430c512453d3000$var$store.preferGamepad = false;
            const distance = event.deltaY;
            this.scrollDistance += distance;
        });
    }
    parseButton(button) {
        if (typeof button === 'string') {
            if ($e430c512453d3000$var$mouseButtons.includes(button)) return $e430c512453d3000$var$mouseButtons.indexOf(button);
            else throw new Error(`There is no mouse button called "${button}"!`);
        } else {
            if (button < $e430c512453d3000$var$mouseButtons.length) return button;
            else throw new Error(`There is no mouse button with the index ${button}!`);
        }
    }
    button(button) {
        const buttonNumber = this.parseButton(button);
        const label = [
            'Left',
            'Middle',
            'Right'
        ][buttonNumber] + ' Mouse Button';
        return {
            label: label,
            query: ()=>this.pressedButtons.has(buttonNumber),
            trigger: {
                label: label,
                query: ()=>{
                    if (this.queuedButtons.has(buttonNumber)) {
                        this.queuedButtons.delete(buttonNumber);
                        return true;
                    }
                    return false;
                }
            }
        };
    }
    pointer() {
        return {
            label: 'Cursor',
            query: ()=>{
                const movement = this.pointerMovement;
                this.pointerMovement = new $e430c512453d3000$var$Vector2(0, 0);
                return movement;
            }
        };
    }
    wheel() {
        return {
            label: 'Mouse wheel',
            query: ()=>{
                const distance = this.scrollDistance;
                this.scrollDistance = 0;
                return distance;
            }
        };
    }
    lockPointer() {
        this.canvas.requestPointerLock();
    }
    unlockPointer() {
        this.document.exitPointerLock();
    }
    isPointerLocked() {
        return this.document.pointerLockElement === this.canvas;
    }
}
/**
 * A map of all the supported key values (property names) and their respective
 * aliases (property values)  that can be used with the `Keyboard` class. The
 * first alias for each key value will be used as a label.
 */ const $e430c512453d3000$var$keyMap = {
    ' ': [
        'Space',
        'Spacebar',
        'Space Bar'
    ],
    'AltGraph': [
        'Alt Gr'
    ],
    'ArrowDown': [
        'Down'
    ],
    'ArrowLeft': [
        'Left'
    ],
    'ArrowRight': [
        'Right'
    ],
    'ArrowUp': [
        'Up'
    ],
    'Backspace': [
        'Backspace'
    ],
    'Control': [
        'Ctrl',
        'Ctl'
    ],
    'Delete': [
        'Delete',
        'Del'
    ],
    'Enter': [
        'Enter',
        'Return'
    ],
    'Escape': [
        'Escape',
        'Esc'
    ],
    'Insert': [
        'Insert',
        'Ins'
    ],
    'PageDown': [
        'Page Down',
        'PgDown'
    ],
    'PageUp': [
        'Page Up',
        'PgUp'
    ],
    'Tab': [
        'Tab'
    ]
};
function $e430c512453d3000$var$findKeyValue(keyString) {
    if (keyString.length === 1) return keyString.toLowerCase();
    for(const keyValue in $e430c512453d3000$var$keyMap)for (const key of $e430c512453d3000$var$keyMap[keyValue]){
        if (keyString.toLowerCase() === key.toLowerCase()) return keyValue;
    }
    return keyString;
}
function $e430c512453d3000$var$getKeyLabel(key) {
    if (key in $e430c512453d3000$var$keyMap) return $e430c512453d3000$var$keyMap[key][0];
    if (key.length === 1) return key.toUpperCase();
    return key;
}
const $e430c512453d3000$var$arrowKeyTemplates = {
    arrows: [
        'Arrow keys',
        [
            'ArrowUp',
            'ArrowLeft',
            'ArrowDown',
            'ArrowRight'
        ]
    ],
    wasd: [
        'WASD',
        [
            'W',
            'A',
            'S',
            'D'
        ]
    ]
};
class $e430c512453d3000$export$16e4d70cc375e707 {
    constructor({ doc: doc = document } = {}){
        this.pressedKeys = new Set();
        this.queuedKeys = new Set();
        this.document = doc;
        this.document.addEventListener('keydown', (event)=>{
            $e430c512453d3000$var$store.preferGamepad = false;
            let key = event.key;
            if (key === key.toUpperCase()) key = key.toLowerCase();
            this.pressedKeys.add(key);
            this.queuedKeys.add(key);
            return false;
        });
        this.document.addEventListener('keyup', (event)=>{
            $e430c512453d3000$var$store.preferGamepad = false;
            let key = event.key;
            if (key === key.toUpperCase()) key = key.toLowerCase();
            this.pressedKeys.delete(key);
            this.queuedKeys.delete(key);
            return false;
        });
    }
    key(key) {
        const keyValue = $e430c512453d3000$var$findKeyValue(key);
        const label = $e430c512453d3000$var$getKeyLabel(keyValue);
        return {
            label: $e430c512453d3000$var$getKeyLabel(keyValue),
            query: ()=>this.pressedKeys.has(keyValue),
            trigger: {
                label: label,
                query: ()=>this.queuedKeys.delete(keyValue)
            }
        };
    }
    directionalKeys(keys, label) {
        let defaultLabel;
        let keyValues;
        if (typeof keys === 'string') {
            const templateId = keys.toLowerCase();
            if (templateId in $e430c512453d3000$var$arrowKeyTemplates) {
                const template = $e430c512453d3000$var$arrowKeyTemplates[templateId];
                defaultLabel = template[0];
                keyValues = template[1];
            } else throw new Error(`Directional key template "${keys}" not found!`);
        } else {
            if (keys.length === 4) {
                keyValues = keys.map((key)=>$e430c512453d3000$var$findKeyValue(key));
                defaultLabel = keys.map((key)=>$e430c512453d3000$var$getKeyLabel(key)).join('');
            } else throw new Error('Directional key templates have to consist of four keys!');
        }
        return {
            label: label || defaultLabel,
            query: ()=>{
                const vector = new $e430c512453d3000$var$Vector2();
                if (this.key(keyValues[0]).query()) vector.y -= 1; // Up
                if (this.key(keyValues[1]).query()) vector.x -= 1; // Left
                if (this.key(keyValues[2]).query()) vector.y += 1; // Down
                if (this.key(keyValues[3]).query()) vector.x += 1; // Right
                return vector;
            }
        };
    }
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ function $e430c512453d3000$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
/**
 * A map of all the supported button numbers (array indices) and their
 * respective aliases (the strings in the arrays) that can be used with the
 * `Gamepad` class. The first alias for each button will be used as a label.
 */ const $e430c512453d3000$var$buttonMap = [
    [
        'A'
    ],
    [
        'B'
    ],
    [
        'X'
    ],
    [
        'Y'
    ],
    [
        'Left Bumper',
        'LB'
    ],
    [
        'Right Bumper',
        'RB'
    ],
    [
        'Left Trigger',
        'LT'
    ],
    [
        'Right Trigger',
        'RT'
    ],
    [
        'Back',
        'View'
    ],
    [
        'Start'
    ],
    [
        'Left Stick'
    ],
    [
        'Right Stick'
    ],
    [
        'Up',
        'DpadUp'
    ],
    [
        'Down',
        'DpadDown'
    ],
    [
        'Left',
        'DpadLeft'
    ],
    [
        'Right',
        'DpadRight'
    ],
    [
        'Home',
        'Guide',
        'Xbox'
    ]
];
function $e430c512453d3000$var$findButtonNumber(button) {
    if (typeof button === 'number') return button;
    let buttonNumber = 0;
    for (const buttonAliases of $e430c512453d3000$var$buttonMap){
        for (const buttonAlias of buttonAliases){
            if (button.toLowerCase() === buttonAlias.toLowerCase()) return buttonNumber;
        }
        buttonNumber++;
    }
    throw new Error(`There is no gamepad button called "${button}"!`);
}
function $e430c512453d3000$var$getButtonLabel(button) {
    return $e430c512453d3000$var$buttonMap[button][0];
}
const $e430c512453d3000$var$gamepadSticks = {
    left: {
        label: 'Left stick',
        xAxis: 0,
        yAxis: 1
    },
    right: {
        label: 'Right stick',
        xAxis: 2,
        yAxis: 3
    }
};
class $e430c512453d3000$export$27a9cd7ebdd38262 {
    constructor({ win: win = window, nav: nav = navigator } = {}){
        this.pressedButtons = new Set();
        this.gamepadTimestamp = 0;
        this.window = win;
        this.navigator = nav;
        this.window.addEventListener('gamepadconnected', ({ gamepad: gamepad })=>{
            if (this.isConnected()) return;
            if (gamepad.mapping === 'standard') {
                this.gamepadIndex = gamepad.index;
                $e430c512453d3000$var$store.preferGamepad = true;
            }
        });
        this.window.addEventListener('gamepaddisconnected', ({ gamepad: gamepad })=>{
            if (this.gamepadIndex !== gamepad.index) return;
            this.gamepadIndex = undefined;
            $e430c512453d3000$var$store.preferGamepad = false;
        });
    }
    isConnected() {
        return this.gamepadIndex !== undefined && this.gamepad.connected;
    }
    get gamepad() {
        const gamepad = this.navigator.getGamepads()[this.gamepadIndex];
        if (gamepad.timestamp > this.gamepadTimestamp) {
            $e430c512453d3000$var$store.preferGamepad = true;
            this.gamepadTimestamp = gamepad.timestamp;
        }
        return gamepad;
    }
    button(button) {
        const buttonNumber = $e430c512453d3000$var$findButtonNumber(button);
        const label = $e430c512453d3000$var$getButtonLabel(buttonNumber);
        return {
            label: label,
            query: ()=>{
                if (!this.isConnected()) return false;
                return this.gamepad.buttons[buttonNumber].pressed;
            },
            fromGamepad: true,
            trigger: {
                label: label,
                query: ()=>{
                    if (!this.isConnected()) return false;
                    if (this.gamepad.buttons[buttonNumber].pressed) {
                        if (this.pressedButtons.has(buttonNumber)) return false;
                        this.pressedButtons.add(buttonNumber);
                        return true;
                    }
                    this.pressedButtons.delete(buttonNumber);
                    return false;
                },
                fromGamepad: true
            }
        };
    }
    stick(stick) {
        let gpStick;
        if (typeof stick === 'string') {
            if (stick in $e430c512453d3000$var$gamepadSticks) gpStick = $e430c512453d3000$var$gamepadSticks[stick];
            else throw new Error(`Gamepad stick "${stick}" not found!`);
        } else gpStick = stick;
        return {
            label: gpStick.label,
            query: ()=>{
                if (!this.isConnected()) return new $e430c512453d3000$var$Vector2(0, 0);
                return new $e430c512453d3000$var$Vector2(this.gamepad.axes[gpStick.xAxis], this.gamepad.axes[gpStick.yAxis]);
            }
        };
    }
    vibrate(duration, { weakMagnitude: weakMagnitude, strongMagnitude: strongMagnitude } = {}) {
        return $e430c512453d3000$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.isConnected()) return;
            const actuator = this.gamepad.vibrationActuator;
            if (!actuator || actuator.type !== 'dual-rumble') return;
            yield actuator.playEffect('dual-rumble', {
                duration: duration,
                strongMagnitude: strongMagnitude,
                weakMagnitude: weakMagnitude
            });
        });
    }
}
function $e430c512453d3000$export$21c0ac7fe1cef1b8(...controls) {
    if (controls.length < 2) throw new Error('Less than two controls specified!');
    return {
        label: controls.map((control)=>control.label).join(' + '),
        query: ()=>{
            for (const control of controls){
                if (!control.query()) return false;
            }
            return true;
        }
    };
}
function $e430c512453d3000$export$252bb8b3bbdf6749(...controls) {
    if (controls.length < 2) throw new Error('Less than two controls specified!');
    return {
        get label () {
            const hasGamepadControls = controls.some((control)=>control.fromGamepad);
            if (!hasGamepadControls) return controls[0].label;
            return ($e430c512453d3000$var$store.preferGamepad ? controls.find((control)=>control.fromGamepad) : controls.find((control)=>!control.fromGamepad)).label;
        },
        query: ()=>{
            let sampleQueryValue;
            for (const control of controls){
                const queryValue = control.query();
                sampleQueryValue = queryValue;
                if (queryValue) return queryValue;
            }
            if (typeof sampleQueryValue === 'boolean') return false;
        }
    };
}



const $bec8d0683b793ab3$var$makeInput = ()=>{
    const keyboard = new (0, $e430c512453d3000$export$16e4d70cc375e707)();
    const gamepad = new (0, $e430c512453d3000$export$27a9cd7ebdd38262)();
    const controls = {
        reset: (0, $e430c512453d3000$export$252bb8b3bbdf6749)(keyboard.key('Backspace'), keyboard.key('Escape'), gamepad.button('Start'), gamepad.button('Back')),
        up: (0, $e430c512453d3000$export$252bb8b3bbdf6749)(keyboard.key('Up'), keyboard.key('W'), gamepad.button('Up')),
        down: (0, $e430c512453d3000$export$252bb8b3bbdf6749)(keyboard.key('Down'), keyboard.key('S'), gamepad.button('Down')),
        left: (0, $e430c512453d3000$export$252bb8b3bbdf6749)(keyboard.key('Left'), keyboard.key('A'), gamepad.button('Left')),
        right: (0, $e430c512453d3000$export$252bb8b3bbdf6749)(keyboard.key('Right'), keyboard.key('D'), gamepad.button('Right')),
        jump: (0, $e430c512453d3000$export$252bb8b3bbdf6749)(keyboard.key('Space'), gamepad.button('A'))
    };
    return ()=>{
        const movement = (0, (/*@__PURE__*/$parcel$interopDefault($fa2c703d63718fcd$exports))).fromValues(0, 0);
        if (gamepad.isConnected()) {
            const raw = gamepad.stick('left').query();
            const stick = (0, (/*@__PURE__*/$parcel$interopDefault($fa2c703d63718fcd$exports))).fromValues(raw.x, -raw.y);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($fa2c703d63718fcd$exports))).length(stick) > 0.1) (0, (/*@__PURE__*/$parcel$interopDefault($fa2c703d63718fcd$exports))).add(movement, movement, stick);
        }
        if (controls.up.query()) movement[1] += 1;
        if (controls.down.query()) movement[1] -= 1;
        if (controls.left.query()) movement[0] -= 1;
        if (controls.right.query()) movement[0] += 1;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($fa2c703d63718fcd$exports))).length(movement) > 1) (0, (/*@__PURE__*/$parcel$interopDefault($fa2c703d63718fcd$exports))).normalize(movement, movement);
        return {
            movement: movement,
            jump: controls.jump.query(),
            reset: controls.reset.query()
        };
    };
};
var $bec8d0683b793ab3$export$2e2bcd8739ae039 = $bec8d0683b793ab3$var$makeInput;





const $55cf76d1bb6b3f31$var$angleDifference = (a, b)=>((a - b + Math.PI) % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI) - Math.PI;
const $55cf76d1bb6b3f31$var$makeCamera = (camera)=>{
    const initialState = {
        position: (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).clone(camera.position),
        lookingAt: (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).fromValues(0, 3, 0),
        angle: 0
    };
    const update = (state, dt, { movement: movement }, playerState)=>{
        state.position = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).clone(state.position);
        state.lookingAt = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).clone(state.lookingAt);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($fa2c703d63718fcd$exports))).length(movement) > 0) {
            const targetAngle = Math.atan2(movement[0], movement[1]);
            if (Math.abs($55cf76d1bb6b3f31$var$angleDifference(targetAngle, state.angle)) < 0.7 * Math.PI) {
                const lerpSpeed = playerState.mode === 'grounded' ? 0.05 : 0.02;
                state.angle = (0, $e3be51b05840559d$export$be967d79ba2e1f9f)(state.angle, targetAngle, lerpSpeed, dt * 60);
            }
        }
        const targetPosition = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).fromValues(-Math.sin(state.angle), 0, -Math.cos(state.angle));
        (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).normalize(targetPosition, targetPosition);
        (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).scaleAndAdd(targetPosition, playerState.position, targetPosition, 10);
        targetPosition[1] += 5;
        (0, $e3be51b05840559d$export$2a33e9eedc5edac3)(state.position, targetPosition, 0.1, dt * 60);
        const targetLookingAt = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).add([], playerState.position, [
            0,
            3,
            0
        ]);
        (0, $e3be51b05840559d$export$2a33e9eedc5edac3)(state.lookingAt, targetLookingAt, 0.2, dt * 60);
        if (playerState.mode !== 'grounded' && targetPosition[1] > state.position[1]) state.position[1] = (0, $e3be51b05840559d$export$3a89f8d6f6bf6c9f)(state.position[1], targetPosition[1], 0.01, dt * 60);
        return state;
    };
    const interpolate = (state, nextState, factor)=>{
        camera.up = [
            0,
            1,
            0
        ];
        (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).copy(camera.position, state.position);
        const lookingAt = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).clone(state.lookingAt);
        (0, $e3be51b05840559d$export$2a33e9eedc5edac3)(camera.position, nextState.position, factor);
        camera.lookAt((0, $e3be51b05840559d$export$2a33e9eedc5edac3)(lookingAt, nextState.lookingAt, factor));
    };
    return [
        update,
        initialState,
        interpolate
    ];
};
var $55cf76d1bb6b3f31$export$2e2bcd8739ae039 = $55cf76d1bb6b3f31$var$makeCamera;




var $fjfo2 = parcelRequire("fjfo2");

const $438ee7cdbf1ee220$var$makePlatform = (center, bounds)=>{
    const [x, y, z] = center;
    const [xp, yp, zp] = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).add([], center, bounds);
    const [xm, ym, zm] = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).subtract([], center, bounds);
    const triangles = [
        [
            [
                xm,
                yp,
                zm
            ],
            [
                xp,
                yp,
                zp
            ],
            [
                xp,
                yp,
                zm
            ]
        ],
        [
            [
                xm,
                yp,
                zm
            ],
            [
                xm,
                yp,
                zp
            ],
            [
                xp,
                yp,
                zp
            ]
        ],
        [
            [
                xp,
                ym,
                zm
            ],
            [
                xm,
                ym,
                zm
            ],
            [
                xp,
                yp,
                zm
            ]
        ],
        [
            [
                xm,
                ym,
                zm
            ],
            [
                xm,
                yp,
                zm
            ],
            [
                xp,
                yp,
                zm
            ]
        ],
        [
            [
                xp,
                ym,
                zp
            ],
            [
                xp,
                yp,
                zp
            ],
            [
                xm,
                ym,
                zp
            ]
        ],
        [
            [
                xm,
                ym,
                zp
            ],
            [
                xp,
                yp,
                zp
            ],
            [
                xm,
                yp,
                zp
            ]
        ],
        [
            [
                xp,
                ym,
                zp
            ],
            [
                xm,
                yp,
                zp
            ],
            [
                xm,
                ym,
                zm
            ]
        ],
        [
            [
                xm,
                ym,
                zm
            ],
            [
                xm,
                yp,
                zp
            ],
            [
                xm,
                yp,
                zm
            ]
        ],
        [
            [
                xp,
                ym,
                zp
            ],
            [
                xp,
                ym,
                zm
            ],
            [
                xp,
                yp,
                zp
            ]
        ],
        [
            [
                xp,
                ym,
                zm
            ],
            [
                xp,
                yp,
                zm
            ],
            [
                xp,
                yp,
                zp
            ]
        ]
    ];
    const smooth = 0.2;
    const hull = (0, $4e84940889c02390$export$32928b00d6f6bffd)([
        [
            xm,
            ym,
            zm
        ],
        [
            xm,
            ym,
            zp
        ],
        [
            xp,
            ym,
            zm
        ],
        [
            xp,
            ym,
            zp
        ],
        [
            xm,
            yp,
            zm
        ],
        [
            xm,
            yp,
            zp
        ],
        [
            xp,
            yp,
            zm
        ],
        [
            xp,
            yp,
            zp
        ]
    ], smooth);
    hull[0].setAttribute('fill', (0, (/*@__PURE__*/$parcel$interopDefault($fjfo2)))());
    const top = (0, $446e3c15142fd568$export$23007700f2a9aecf)([
        [
            xm,
            yp,
            zm
        ],
        [
            xp,
            yp,
            zm
        ],
        [
            xp,
            yp,
            zp
        ],
        [
            xm,
            yp,
            zp
        ]
    ], true, smooth);
    top[0].setAttribute('fill', 'hsla(0, 50%, 100%, 40%)');
    top[0].setAttribute('stroke', 'none');
    const bottom = (0, $446e3c15142fd568$export$23007700f2a9aecf)([
        [
            xm,
            ym,
            zm
        ],
        [
            xp,
            ym,
            zm
        ],
        [
            xp,
            ym,
            zp
        ],
        [
            xm,
            ym,
            zp
        ]
    ], true, smooth);
    bottom[0].setAttribute('fill', 'hsla(0, 50%, 0%, 10%)');
    bottom[0].setAttribute('stroke', 'none');
    const fill = (0, $799e53e71683ce28$export$184bb8159eb3eb47)(center, [
        bottom,
        hull,
        top
    ]);
    const outline = (0, $4e84940889c02390$export$32928b00d6f6bffd)([
        [
            xm,
            ym,
            zm
        ],
        [
            xm,
            ym,
            zp
        ],
        [
            xp,
            ym,
            zm
        ],
        [
            xp,
            ym,
            zp
        ],
        [
            xm,
            yp,
            zm
        ],
        [
            xm,
            yp,
            zp
        ],
        [
            xp,
            yp,
            zm
        ],
        [
            xp,
            yp,
            zp
        ]
    ], smooth);
    outline[0].setAttribute('stroke', 'black');
    outline[0].setAttribute('stroke-width', 5);
    outline[0].setAttribute('fill', 'none');
    const svg = (0, $799e53e71683ce28$export$184bb8159eb3eb47)(center, [
        fill,
        outline
    ]);
    return [
        triangles,
        svg
    ];
};
var $438ee7cdbf1ee220$export$2e2bcd8739ae039 = $438ee7cdbf1ee220$var$makePlatform;


const $5424bd6f451fcf28$var$platforms = [
    (0, $438ee7cdbf1ee220$export$2e2bcd8739ae039)([
        -5,
        2,
        12.5
    ], [
        3,
        1,
        2.5
    ]),
    (0, $438ee7cdbf1ee220$export$2e2bcd8739ae039)([
        15,
        10,
        12
    ], [
        2,
        1,
        2
    ]),
    (0, $438ee7cdbf1ee220$export$2e2bcd8739ae039)([
        25,
        15,
        12
    ], [
        2,
        1,
        2
    ]),
    (0, $438ee7cdbf1ee220$export$2e2bcd8739ae039)([
        35,
        20,
        12
    ], [
        3,
        1,
        2
    ]),
    (0, $438ee7cdbf1ee220$export$2e2bcd8739ae039)([
        40,
        25,
        12
    ], [
        2,
        1,
        2
    ]),
    (0, $438ee7cdbf1ee220$export$2e2bcd8739ae039)([
        40,
        30,
        16
    ], [
        2,
        1,
        2
    ]),
    (0, $438ee7cdbf1ee220$export$2e2bcd8739ae039)([
        30,
        35,
        16
    ], [
        2,
        1,
        2
    ]),
    (0, $438ee7cdbf1ee220$export$2e2bcd8739ae039)([
        30,
        40,
        8
    ], [
        2,
        1,
        2
    ]),
    (0, $438ee7cdbf1ee220$export$2e2bcd8739ae039)([
        25,
        45,
        0
    ], [
        3,
        1,
        3
    ])
];
const $5424bd6f451fcf28$var$width = 12;
const $5424bd6f451fcf28$var$height = 6;
const $5424bd6f451fcf28$var$mapCoordinate = ([x, y, z])=>[
        x * 3,
        Math.sin(x / 3) * 3 + y + Math.sin(z / 4) * 3,
        z * 3
    ];
const $5424bd6f451fcf28$var$terrainTriangles = [
    ...Array($5424bd6f451fcf28$var$width * 2 + 1).keys()
].map((i)=>[
        ...Array($5424bd6f451fcf28$var$height * 2).keys()
    ].map((j)=>{
        const left = i - $5424bd6f451fcf28$var$width - 1;
        const spacing = Math.tan(Math.PI / 3);
        const bottom = (j - $5424bd6f451fcf28$var$height) * spacing;
        if (i % 2 !== j % 2) return [
            [
                left,
                0,
                bottom
            ],
            [
                left + 1,
                0,
                bottom + spacing
            ],
            [
                left + 2,
                0,
                bottom
            ]
        ];
        return [
            [
                left,
                0,
                bottom + spacing
            ],
            [
                left + 2,
                0,
                bottom + spacing
            ],
            [
                left + 1,
                0,
                bottom
            ]
        ];
    })).flat().map((triangle)=>triangle.map($5424bd6f451fcf28$var$mapCoordinate));
const [$5424bd6f451fcf28$var$terrainGroups, $5424bd6f451fcf28$var$getFloorIntersection, $5424bd6f451fcf28$var$getWallIntersection] = (0, $806cd3fd01d2a855$export$2e2bcd8739ae039)([
    ...$5424bd6f451fcf28$var$terrainTriangles,
    ...$5424bd6f451fcf28$var$platforms.map((platform)=>platform[0]).flat(),
    // random platform
    [
        [
            3,
            4,
            3
        ],
        [
            6,
            4,
            7
        ],
        [
            5,
            4,
            1
        ]
    ],
    // back wall
    [
        [
            30,
            0,
            31
        ],
        [
            -30,
            0,
            31
        ],
        [
            0,
            20,
            31
        ]
    ],
    // cube platform
    [
        [
            2,
            8,
            10
        ],
        [
            8,
            8,
            15
        ],
        [
            8,
            8,
            10
        ]
    ],
    [
        [
            2,
            8,
            10
        ],
        [
            2,
            8,
            15
        ],
        [
            8,
            8,
            15
        ]
    ],
    [
        [
            8,
            3,
            10
        ],
        [
            2,
            3,
            10
        ],
        [
            8,
            8,
            10
        ]
    ],
    [
        [
            2,
            3,
            10
        ],
        [
            2,
            8,
            10
        ],
        [
            8,
            8,
            10
        ]
    ],
    [
        [
            8,
            3,
            15
        ],
        [
            8,
            8,
            15
        ],
        [
            2,
            3,
            15
        ]
    ],
    [
        [
            2,
            3,
            15
        ],
        [
            8,
            8,
            15
        ],
        [
            2,
            8,
            15
        ]
    ],
    [
        [
            2,
            3,
            15
        ],
        [
            2,
            8,
            15
        ],
        [
            2,
            3,
            10
        ]
    ],
    [
        [
            2,
            3,
            10
        ],
        [
            2,
            8,
            15
        ],
        [
            2,
            8,
            10
        ]
    ],
    [
        [
            8,
            3,
            15
        ],
        [
            8,
            3,
            10
        ],
        [
            8,
            8,
            15
        ]
    ],
    [
        [
            8,
            3,
            10
        ],
        [
            8,
            8,
            10
        ],
        [
            8,
            8,
            15
        ]
    ],
    // concave pyramid
    [
        [
            -20,
            0,
            10
        ],
        [
            -20,
            0,
            5
        ],
        [
            -20,
            5,
            10
        ]
    ],
    [
        [
            -20,
            0,
            10
        ],
        [
            -20,
            5,
            10
        ],
        [
            -15,
            0,
            10
        ]
    ],
    [
        [
            -25,
            0,
            10
        ],
        [
            -20,
            5,
            10
        ],
        [
            -20,
            0,
            5
        ]
    ],
    [
        [
            -20,
            0,
            15
        ],
        [
            -15,
            0,
            10
        ],
        [
            -20,
            5,
            10
        ]
    ],
    [
        [
            -20,
            0,
            15
        ],
        [
            -20,
            5,
            10
        ],
        [
            -25,
            0,
            10
        ]
    ],
    // corner elevator
    ...[
        ...Array(100).keys()
    ].map((i)=>[
            [
                -35,
                i * 5,
                -30
            ],
            [
                -35,
                i * 5,
                -25
            ],
            [
                -30,
                i * 5,
                -30
            ]
        ])
]);
const [$5424bd6f451fcf28$var$player, $5424bd6f451fcf28$var$updatePlayer, $5424bd6f451fcf28$var$initialPlayerState, $5424bd6f451fcf28$var$interpolatePlayer] = (0, $1b5e89835ea262cf$export$2e2bcd8739ae039)($5424bd6f451fcf28$var$getFloorIntersection, $5424bd6f451fcf28$var$getWallIntersection);
const $5424bd6f451fcf28$var$groundCurveScale = 2;
const $5424bd6f451fcf28$var$groundCurves = [
    ...Array(20 * $5424bd6f451fcf28$var$groundCurveScale).keys()
].map((i)=>{
    const curveA = (0, $446e3c15142fd568$export$23007700f2a9aecf)([
        ...Array(20 * $5424bd6f451fcf28$var$groundCurveScale).keys()
    ].map((j)=>$5424bd6f451fcf28$var$mapCoordinate([
            i / $5424bd6f451fcf28$var$groundCurveScale - 10,
            0,
            j / $5424bd6f451fcf28$var$groundCurveScale - 10
        ])), false);
    curveA[0].setAttribute('fill', 'none');
    curveA[0].setAttribute('stroke', (0, (/*@__PURE__*/$parcel$interopDefault($fjfo2)))({
        hue: 'D2B48C'
    }));
    curveA[0].setAttribute('stroke-width', 5);
    const curveB = (0, $446e3c15142fd568$export$23007700f2a9aecf)([
        ...Array(20 * $5424bd6f451fcf28$var$groundCurveScale).keys()
    ].map((j)=>$5424bd6f451fcf28$var$mapCoordinate([
            j / $5424bd6f451fcf28$var$groundCurveScale - 10,
            0,
            i / $5424bd6f451fcf28$var$groundCurveScale - 10
        ])), false);
    curveB[0].setAttribute('fill', 'none');
    curveB[0].setAttribute('stroke', (0, (/*@__PURE__*/$parcel$interopDefault($fjfo2)))({
        hue: 'D2B48C'
    }));
    curveB[0].setAttribute('stroke-width', 5);
    return [
        curveA,
        curveB
    ];
}).flat();
const $5424bd6f451fcf28$var$cubeBlob = (0, $4e84940889c02390$export$32928b00d6f6bffd)([
    [
        2,
        8,
        10
    ],
    [
        8,
        8,
        10
    ],
    [
        8,
        8,
        15
    ],
    [
        2,
        8,
        15
    ],
    [
        5,
        6,
        12.5
    ]
], 0.1);
$5424bd6f451fcf28$var$cubeBlob[0].setAttribute('fill', 'green');
$5424bd6f451fcf28$var$cubeBlob[0].setAttribute('stroke', 'none');
const [$5424bd6f451fcf28$var$svg, $5424bd6f451fcf28$var$camera, $5424bd6f451fcf28$var$updateSvg] = (0, $df082aa08ed5892b$export$c03da5d65ddac336)(1920, 1080, [
    ...$5424bd6f451fcf28$var$groundCurves,
    ...$5424bd6f451fcf28$var$platforms.map((platform)=>platform[1]),
    $5424bd6f451fcf28$var$cubeBlob,
    $5424bd6f451fcf28$var$player
]);
$5424bd6f451fcf28$var$svg.setAttribute('id', 'main');
document.body.appendChild($5424bd6f451fcf28$var$svg);
$5424bd6f451fcf28$var$camera.position = [
    0,
    5,
    -5
];
$5424bd6f451fcf28$var$camera.fov = Math.PI / 2;
const $5424bd6f451fcf28$var$getInput = (0, $bec8d0683b793ab3$export$2e2bcd8739ae039)();
const [$5424bd6f451fcf28$var$updateCamera, $5424bd6f451fcf28$var$initialCameraState, $5424bd6f451fcf28$var$interpolateCamera] = (0, $55cf76d1bb6b3f31$export$2e2bcd8739ae039)($5424bd6f451fcf28$var$camera);
let $5424bd6f451fcf28$var$state = {
    time: 0,
    player: $5424bd6f451fcf28$var$initialPlayerState,
    camera: $5424bd6f451fcf28$var$initialCameraState
};
let $5424bd6f451fcf28$var$nextState = $5424bd6f451fcf28$var$state;
const $5424bd6f451fcf28$var$update = (state, dt)=>{
    const input = $5424bd6f451fcf28$var$getInput();
    const cameraDirection = (0, (/*@__PURE__*/$parcel$interopDefault($589baecd24708921$exports))).subtract([], state.camera.lookingAt, state.camera.position);
    const cameraRotation = -Math.atan2(cameraDirection[0], cameraDirection[2]);
    (0, (/*@__PURE__*/$parcel$interopDefault($fa2c703d63718fcd$exports))).rotate(input.movement, input.movement, cameraRotation);
    state.player = input.reset ? $5424bd6f451fcf28$var$initialPlayerState : $5424bd6f451fcf28$var$updatePlayer(state.player, dt, input);
    state.camera = $5424bd6f451fcf28$var$updateCamera(state.camera, dt, input, state.player);
    state.time += dt;
    return state;
};
let $5424bd6f451fcf28$var$accumulate = 0;
let $5424bd6f451fcf28$var$lastTime = null;
const $5424bd6f451fcf28$var$cycle = (currentTime)=>{
    if (!$5424bd6f451fcf28$var$lastTime) $5424bd6f451fcf28$var$lastTime = currentTime;
    const timeSinceLastRender = (currentTime - $5424bd6f451fcf28$var$lastTime) / 1000;
    $5424bd6f451fcf28$var$lastTime = currentTime;
    if (timeSinceLastRender > 0.5) // a lot of time passed, treat it as paused
    $5424bd6f451fcf28$var$accumulate = 0;
    else $5424bd6f451fcf28$var$accumulate += timeSinceLastRender;
    const timePerUpdate = 1 / 240;
    while($5424bd6f451fcf28$var$accumulate > timePerUpdate){
        $5424bd6f451fcf28$var$state = $5424bd6f451fcf28$var$nextState;
        $5424bd6f451fcf28$var$nextState = (0, $3kW6u.default)($5424bd6f451fcf28$var$state, (draft)=>$5424bd6f451fcf28$var$update(draft, timePerUpdate));
        $5424bd6f451fcf28$var$accumulate -= timePerUpdate;
    }
    const interpolate = $5424bd6f451fcf28$var$accumulate / timePerUpdate;
    $5424bd6f451fcf28$var$interpolateCamera($5424bd6f451fcf28$var$state.camera, $5424bd6f451fcf28$var$nextState.camera, interpolate);
    $5424bd6f451fcf28$var$interpolatePlayer($5424bd6f451fcf28$var$state.player, $5424bd6f451fcf28$var$nextState.player, interpolate);
    $5424bd6f451fcf28$var$updateSvg();
    window.requestAnimationFrame($5424bd6f451fcf28$var$cycle);
};
window.requestAnimationFrame($5424bd6f451fcf28$var$cycle);
console.log('hello world :o');


//# sourceMappingURL=foremost-backbone.ec1f37d4.js.map
